import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {TransferWithinAStation,ListAlt,Inbox,Drafts,Money,AirlineSeatReclineNormal,LastPage,AllInclusive,Add,MoreVert,Schedule,Block,Subway,Edit,Delete,ErrorOutline,Visibility,Image,Work,BeachAccess,Place,FindReplace,HelpOutline,DepartureBoard,RemoveCircleOutline,PersonAdd,Alarm,HourglassEmpty,Done,Close,EditAttributes,CropFree,ConfirmationNumber,Filter9Plus,CancelPresentation,PersonOutlined,AirportShuttle} from '@material-ui/icons';

import ScheduleIcon from '@material-ui/icons/Schedule';

import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  LinearProgress,
  FormHelperText,
  CircularProgress,
  Chip,
  List,ListItem,ListItemText,ListItemAvatar,Avatar,Stepper,Step,StepLabel,
  ListItemSecondaryAction,Popover,Slide,Grid,useMediaQuery,ListItemIcon,ButtonGroup,Badge
} from "@material-ui/core";

import {MuiPickersUtilsProvider,DatePicker,TimePicker,KeyboardTimePicker,DateTimePicker} from "@material-ui/pickers";

import {withLocalize,Translate} from "react-localize-redux";
import MUIDataTable from "mui-datatables";
import DateFnsUtils from "@date-io/date-fns";

import Format from "date-fns/format";

import parseISO from 'date-fns/parseISO';

import { useSnackbar } from 'notistack';

import UserInfo from "./login_info";

import axios from 'axios';

import {TransportService,AdminService,Permissions} from "./../../utils/web_config_2";

import Ischedules from "../../assets/svg/schedules.svg";
import Ibuses from "../../assets/svg/buses.svg";
import Idrivers from "../../assets/svg/driver.svg"; 
import iticketdetails from "../../assets/svg/ticket_details.svg";

import Link from '@material-ui/core/Link';

import MaskedInput from "react-text-mask";
import { add } from 'date-fns';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        flexFlow:1,
        [theme.breakpoints.up('sm')]:{
          marginLeft:250,
        }
      },
  btn:{
    textTransform:"capitalize",
    margin:5

  },
  formTitle:{
    flexGrow:1,
},chip: {
  margin: theme.spacing(0.5),
},btn2: {
  textTransform: "capitalize",
  margin:theme.spacing(0.5)
},
appBar: {
  position: 'relative',
},title: {
  marginLeft: theme.spacing(2),
  flex: 1,
}
}));

const TextMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
}

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};


function RouteSchedule() {
  const classes = useStyles1();
  const [operatorData, setOperatorData] = useState({});
  const history = useHistory();
  const [scheduleMessage,setScheduleMessage]=useState("Loading...");
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [routeName,setRouteName]=useState("Schedule list");
  var React = require('react');
  var QRCode = require('qrcode.react');
  const Theme = useTheme();
  const matches = useMediaQuery(Theme.breakpoints.up("sm"));

  useEffect(()=>{

    var data = {};
    const data1 = localStorage.getItem("nx_op");
    if (data1 != null) {
      data = JSON.parse(data1);
    }
    setOperatorData(data);
    
    getRoutes(data.token);

  
  getRoutes(data.token);
  getVehicles(data.token);
  getDrivers(data.token);

   },[]);





  const handleEditCloser = () => {
    setDialogedit(false);
                  // reset form
                  setVehicle({ value: '', error: '' });
                  setAllowedSeats({ value: 0, error: '' });
                  setDriver({ value: '', error: '' });
                  setScheduleDate({ value: '', error: '' });
                  setScheduleTime({ value: '', error: '' });
                  setEndDate({ value: '', error: '' });
                  setMode({ value: '', error: '' });
                  setDescription({ value: '', error: '' });
                  
  };
   


   const getDate=()=>{
    return Format(new Date(), ["yyyy-MM-dd",]);
 }


 const [routeMessage,setRouteMessage]=useState("Loading...");


// route table 
const columns = [
  
  {
   name: "name",
   label: "Name",
   options: {
    filter: true,
    sort: false,
   }
  },{
    name: "cost",
    label: "Cost",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "currency",
    label: <Translate id="operator_route.table.currency" />,
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "status",
    label: "Status",
    options: {
     filter: true,
     sort: true,
     display:false,
     customBodyRender: (value, tableMeta, updateValue) => {

      if(value=="INITIAL" || value=="INTERMIDIATE_ROUTES_GENERATED"){
        return (
          <Chip
          color="secondary"
          variant="outlined"
          size="small"
          label={value=="INITIAL"?"Captured":"Generated"}
          onDelete={()=>{}}
          deleteIcon={<HourglassEmpty />}
        ></Chip>
            
        );
      }else{
        return (
          <Chip
          color="primary"
          label={"Completed"}
          size="small"
          variant="outlined"
          icon={<Done />}
        ></Chip>  
        );
      }
   }
    }
   },
   {
    name: "id",
    label: "Schedules",
    options: {
      display:true,
     filter: true,
     sort: true,
     customBodyRender: (value, tableMeta, updateValue) => {

      return (
        <Chip
        color="primary"
        variant="outlined"
        label={"View Schedules"}
        onClick={()=>{
          var obj=routes.find((r)=>r.id==value);
          setRouteName("Schedule list > "+obj.name);
          setRoute_code({value:obj.code,erro:""});
          setSchedules([]);
          setRouteId(value);
          getSchedules(value,Format(new Date(), ["yyyy-MM-dd",]));
          setScheduleDialog(true);


          setOpenSchedule(true);
          
          
        }}
        icon={<Alarm/>}
      ></Chip>
          
      );
   
  }
    }
   },
 ];
 
 const options = {
  textLabels: {
    body: {
      noMatch: "No routes available"
    },
  },
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 10,
   elevation:0,
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
  <Box display="flex">



      </Box>
  ),
 };


// schedule table

 const columns1 = [

  {
    name: "id",
    label: "id",
    options: {
     display:false,
     filter: true,
     sort: true,
    }
   },
  {
    name: "id",
    label: "Time",
    options: {
     filter: true,
     sort: true, 
     customBodyRender: (value, tableMeta, updateValue) => {
      var obj=schedules.find((s)=>s.id==value);
       var dt=obj.date_time;
       var d = new Date(dt);
     return (
     <Typography color="primary"><Link href="#" onClick={()=>{
      
      var obj=schedules.find((item,i) => {
        return item.id == value;
        });
  
        setScheduleid(value);
        setVehicle({value:obj.vehicle_id,error:""});
        setRoute({value:obj.route_id,error:""});
        setDriver({value:obj.driver_id,error:""});
        setDate({value:obj.date_time,error:""});
        setTime({value:obj.date_time,error:""});
        setMode({value:obj.scheduling_mode,error:""});
        setDescription({value:"description",error:""});
        setDevice({value:"1",error:""});
        
        setAllowedSeats({value:obj.total_allowed_seats,error:""});

        // Format(Date.parse(obj.date_time), ["yyyy-MM-dd"])
      
        // console.log("schdeule timw date=====", Format(parseISO(obj.date_time), ["H:mm"]));
      
        var ExistingDate=obj.date_time.split(" ");
      
        // console.log("date",ExistingDate[0]);
      
        // console.log("time",ExistingDate[1]);
      
        var datetime = new Date(ExistingDate[0]);
      
        setScheduleDate({value:Format(datetime, ["yyyy-MM-dd"]),error:""});

        setScheduleDate({value:Format(datetime, ["yyyy-MM-dd"]),error:""});

        setScheduleTime({value:ExistingDate[1],error:""});
        
        setDialogedit(true);



     }}>
       {/* {"time"} */}
     {Format(parseISO(obj.date_time), ["H:mm"])}
   </Link></Typography>
     );

     }  
    }
   },
  {
   name: "driver_name",
   label: <Translate id="operator_schedule.table.driver_name" />,
   options: {
    filter: true,
    sort: true,
   }
  },
  // {
  //  name: "code",
  //  label: <Translate id="operator_schedule.table.code" />,
  //  options: {
  //   filter: true,
  //   sort: false,
  //  }
  // },
  // {
  //  name: "route",
  //  label: <Translate id="operator_schedule.table.route" />,
  //  options: {
  //   filter: true,
  //   sort: false,
  //  }
  // },
  {
   name: "plate_number",
   label: <Translate id="operator_schedule.table.plate_number" />,
   options: {
    filter: true,
    sort: false,
   }
  },{
    name: "total_seats",
    label: "Vehicle Capacity",
    options: {
     filter: true,
     sort: false,
  //    customBodyRender: (value, tableMeta, updateValue) => {

  //     var obj=schedules.find((s)=>s.id==value);
  //      var tot=obj.total_seats;
  //    return (
  //    <Typography color="primary"><Link href="#" onClick={()=>{
  //     get_(value);
  //    }}>
  //    {tot}
  //  </Link></Typography>
  //    );

  //    }
    }
   },
   {
    name: "id",
    label: "Allowed Seats",
    options: {
     filter: true,
     sort: false,
     customBodyRender: (value, tableMeta, updateValue) => {

      var obj=schedules.find((s)=>s.id==value);
       var tot=obj.total_allowed_seats;
     return (
     <Typography color="primary"><Link href="#" onClick={()=>{
      get_tickets(value);
     }}>
      
     {tot}
   </Link></Typography>
     );

     }
    }
   }
   ,{
    name: "id",
    label: <Translate id="operator_schedule.table.total_sold_seat" />,
    options: {
     filter: true,
     sort: false,
     customBodyRender: (value, tableMeta, updateValue) => {
      
    //   return(
    //     <Link href="#" onClick={()=>{

    //           // get total ticke per schedule

    //           get_tickets(value);

    //          }}>
    //        <GetTicketSchedule id={value} />
    //        </Link>
    //   );

      var obj=schedules.find((s)=>s.id==value);
       var tot=obj.total_from_head_sold_seats;
     return (
     <Typography color="primary"><Link href="#" onClick={()=>{
      get_tickets(value);
     }}>
      View Details
     {/* {tot} */}
   </Link></Typography>
     );

     }
    }
   },{
    name: "total_sales",
    label: "Total sales",
    options: {
     filter: true,
     sort: false,
     customBodyRender: (value, tableMeta, updateValue) => {
       return(
<Typography>{formatMoney(value,0) }</Typography>
       );
     }
    }
   },{
    name: "number_of_luggages",
    label: "Luggages",
    options: {
     filter: true,
     sort: false,
     customBodyRender: (value, tableMeta, updateValue) => {
       return(
<Typography>{formatMoney(value,0) }</Typography>
       );
     }
    }
   },{
    name: "total_luggage_amount",
    label: "Luggages Sales",
    options: {
     filter: true,
     sort: false,
     customBodyRender: (value, tableMeta, updateValue) => {
       return(
<Typography>{formatMoney(value,0) }</Typography>
       );
     }
    }
   },{
    name: "scheduling_mode",
    label: <Translate id="operator_schedule.table.scheduling_mode" />,
    options: {
     filter: true,
     sort: false,
    }
   },
   {
    name: "id",
    label: "Status",
    options: {
     filter: true,
     sort: false,
     customBodyRender: (value, tableMeta, updateValue) => {
       var obj=schedules.find((s)=>s.id==value);
       var stat=obj.status;
      return (
        <Box>

           <Chip
        color={stat=='SCHEDULED'?"primary":"secondary"}
        label={stat}
        variant="outlined"
        onClick={(e)=>{
          setStatus({value:stat,error:""});
          setScheduleid(value);
          handleEditOpenStatus(e);

        }}
        icon={stat=='SCHEDULED'?<Done/>:<HourglassEmpty />}
      ></Chip>

        <Popover
        id={idStatus}
        open={openEditStatus}
        anchorEl={anchorElStatus}
        onClose={handleEditCloseStatus}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        elevation={1}
      >

        <Box p={2}>

          <Typography color="textSecondary">
            Change Schedule Status
          </Typography>

         <Box mt={2} mb={2}>

         <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
          <InputLabel htmlFor="status">Choose status</InputLabel>
        <Select
        size="small"
        helperText={"error"} 
        label="Select status"
        inputProps={{
          name: 'status',
          id: 'status',
        }}

        value={status.value}
        defaultValue={status.value}
        error={status.error!==""}
        onChange={(e)=>{
          if(e.target.value===''){
            setStatus({value:"",error:"Selec status"});
          }else{
            setStatus({value:e.target.value,error:""});
          }
        }}
        >
          <MenuItem value="">
            <em>None</em>
          
          </MenuItem>
          <MenuItem value={"INITIAL"}>Initial</MenuItem>
         <MenuItem value={"SCHEDULED"}>Scheduled</MenuItem>
         <MenuItem value={"CANCELED"}>Canceled</MenuItem>
         <MenuItem value={"CLOSED"}>Closed</MenuItem>

        </Select>
      <FormHelperText  error={status.error!=""}>{status.error}</FormHelperText>
      </FormControl>

          </Box>
        
          <Button
            variant="outlined"
            size="small"
            color="primary"
            className={classes.btn2}
            onClick={handleEditCloseStatus}
          >
            Close
          </Button>

          <Button
            variant="contained"
            size="small"
            color="primary"
            className={classes.btn}
            disableElevation
            disabled={statusLoad.load}
            onClick={()=>{
              changeSchedule();
            }}
          >
            {statusLoad.load? <CircularProgress color="secondary" size={23} /> : "Save"}
          </Button>

        </Box>
    
      </Popover>

        </Box>
        
          
      );
    }
    },
    
   },{
    name: "scheduled_by",
    label:"Created By",
    options: {
     filter: true,
     sort: false,
    }
   },
   {
    name: "created_at",
    label:"Created At",
    options: {
     filter: true,
     sort: false,
    }
   },
   {
    name: "updated_by",
    label: "Updated By",
    options: {
     filter: true,
     sort: false
    }
   },
   {
    name: "updated_at",
    label: "Updated At",
    options: {
     filter: true,
     sort: false,
    }
   },
   
 ];

 // schedule table

 const columnsTrajet = [

  {
    name: "id",
    label: "id",
    options: {
     display:false,
     filter: true,
     sort: true,
    }
   },
  {
    name: "fromDate",
    label: "From Date",
    options: {
     filter: true,
     sort: true 
    }
   },
   {
    name: "toDate",
    label: "To Date",
    options: {
     filter: true,
     sort: true 
    }
   },
   {
    name: "fromWorkingHours",
    label: "From Working Hours",
    options: {
     filter: true,
     sort: true 
    }
   },
   {
    name: "toWorkingHours",
    label: "To Working Hours",
    options: {
     filter: true,
     sort: true 
    }
   },
   {
    name: "eachAfterMinutes",
    label: "Each AFter Minutes",
    options: {
     filter: true,
     sort: true 
    }
   },
   {
    name: "routeName",
    label: "Route Name",
    options: {
     filter: true,
     sort: true 
    }
   },
   {
    name: "numberPlate",
    label: "Plate Number",
    options: {
     filter: true,
     sort: true 
    }
   },
   {
    name: "schedulingMode",
    label: "Scheduling Mode",
    options: {
     filter: true,
     sort: true 
    }
   },
   {
    name: "numberOfSchedules",
    label: "Schedules",
    options: {
     filter: true,
     sort: true 
    }
   },
   {
    name: "numberOfDays",
    label: "Days",
    options: {
     filter: true,
     sort: true 
    }
   },
   {
    name: "trajectType",
    label: "Trajet Type",
    options: {
     filter: true,
     sort: true 
    }
   },
   {
    name: "trajectType",
    label: "Trajet Type",
    options: {
     filter: true,
     sort: true 
    }
   }, 
 ];

// tickets table




const columns2 = [

  {
    name: "id",
    label: "id",
    options: {
     display:false,
     filter: true,
     sort: true,
    }
   },
  {
    name: "ticket_number",
    label: "Ticket Number",
    options: {
     filter: true,
     sort: true,
     customBodyRender: (value, tableMeta, updateValue) => {
      
      return(
        <Box>
      <Typography><Link  href="#" onClick={(e)=>{
      

        var obj=tickets.find((t)=>t.ticket_number===value);
        setTicketData(obj);

        openTicketMenu(e); 
      }} color="primary">{value}</Link></Typography>
         <Popover
        id={id}
        open={openTicket}
        anchorEl={anchorEl}
        onClose={closeTicketMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        elevation={1}
      >
        <List component="nav" aria-label="main mailbox folders">
        <ListItem button onClick={(e)=>{
          
setTicketDialog(true);
closeTicketMenu(e);
        }}>
          <ListItemIcon>
            <ConfirmationNumber/>
          </ListItemIcon>
          <ListItemText primary="Details" />
        </ListItem>


        <ListItem button onClick={(e)=>{
         
          setTransferDialog(true);
          closeTicketMenu(e);
        }}>
          <ListItemIcon>
            <TransferWithinAStation />
          </ListItemIcon>
          <ListItemText primary="Transfer" />
        </ListItem>


      </List>
      </Popover>
      </Box>
      )
   
   }
    }
   },
   {
    name: "promotion_code",
    label: "Client Code",
    options: {
     filter: true,
     sort: false,
    }
   },
  {
   name: "owner_type",
   label: "Owner",
   options: {
    filter: true,
    sort: true,
    display:false
   }
  },
  {
   name: "customer_names",
   label: "Customer names",
   options: {
    filter: true,
    sort: false,
   }
  },
  {
   name: "route",
   label: "Route",
   options: {
    filter: true,
    sort: false,
   }
  },
  {
   name: "actual_ticket_amount",
   label: "Total amount",
   options: {
    filter: true,
    sort: false,
   }
  },{
    name: "currency",
    label: "Currency",
    options: {
     filter: true,
     sort: false,
    }
   },{
    name: "seat_number",
    label:"Seat Number",
    options: {
     filter: true,
     sort: false,
    }
   },{
    name: "ticket_type",
    label: "Ticket Type",
    options: {
     filter: true,
     sort: false,
    }
   },   
   {
    name: "channel_type",
    label: "Channel Type",
    options: {
     filter: true,
     sort: false,
    }
   },
   {
    name: "payment_mode",
    label: "Payment mode",
    options: {
     filter: true,
     sort: false,
    }
   },
   {
    name: "cashier_name",
    label: "Cashier names",
    options: {
     filter: true,
     sort: true,
    }
   },{
    name: "generated_at",
    label: "Date",
    options: {
     filter: true,
     sort: false,
    }
   },
   {
    name: "device_number",
    label: "Device Number",
    options: {
     filter: true,
     sort: false,
    }
   },
   {
    name: "status",
    label: "Status",
    options: {
     filter: true,
     sort: false,
     customBodyRender: (value, tableMeta, updateValue) => {
       if(value=="Second Tap" || value=="Complete"){
         return ( <Chip
         color="primary"
         variant="outlined"
         label={value}
         icon={<Done/>}
       />);
       }else{
        return (
          <Chip
          variant="outlined"
          color={value=='USED'?"primary":"secondary"}
          label={value}
          icon={value=='USED'?<Done/>:<HourglassEmpty />}
       />     
        );
       }
    
    }
    },
    
   }
 ];



 // luggage table


 const columns3 = [

  {
    name: "id",
    label: "id",
    options: {
     display:false,
     filter: true,
     sort: true,
    }
   },
  {
    name: "ticket_number",
    label: "Ticket Number",
    options: {
     filter: true,
     sort: true,
     customBodyRender: (value, tableMeta, updateValue) => {
      
      return(
        <Box>
      <Typography><Link href="#" color="primary">{value}</Link></Typography>
         <Popover
        id={id}
        open={openTicket}
        anchorEl={anchorEl}
        onClose={closeTicketMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        elevation={1}
      >
        <List component="nav" aria-label="main mailbox folders">
        <ListItem button onClick={(e)=>{
          
setTicketDialog(true);
closeTicketMenu(e);
        }}>
          <ListItemIcon>
            <ConfirmationNumber/>
          </ListItemIcon>
          <ListItemText primary="Details" />
        </ListItem>


        <ListItem button onClick={(e)=>{
         
          setTransferDialog(true);
          closeTicketMenu(e);
        }}>
          <ListItemIcon>
            <TransferWithinAStation />
          </ListItemIcon>
          <ListItemText primary="Transfer" />
        </ListItem>


      </List>
      </Popover>
      </Box>
      )
   
   }
    }
   },
   {
    name: "cashier_name",
    label: "Cashier names",
    options: {
     filter: true,
     sort: true,
    }
   },
  {
   name: "owner_type",
   label: "Owner",
   options: {
    filter: true,
    sort: true,
    display:false
   }
  },
  {
   name: "customer_names",
   label: "Sender names",
   options: {
    filter: true,
    sort: false,
   }
  },
  {
   name: "route",
   label: "Route",
   options: {
    filter: true,
    sort: false,
   }
  },{
    name: "luggage_weight",
    label:"Weight",
    options: {
     filter: true,
     sort: false,
    }
   },
  {
   name: "actual_ticket_amount",
   label: "Total amount",
   options: {
    filter: true,
    sort: false,
   }
  },{
    name: "currency",
    label: "Currency",
    options: {
     filter: true,
     sort: false,
    }
   },{
    name: "description",
    label: "Description",
    options: {
     filter: true,
     sort: false,
    } 
   },{
    name: "payment_mode",
    label: "Payment mode",
    options: {
     filter: true,
     sort: false,
    }
   },
   {
    name: "generated_at",
    label: "Date",
    options: {
     filter: true,
     sort: false,
    }
   },
   {
    name: "status",
    label: "Status",
    options: {
     filter: true,
     sort: false,
     customBodyRender: (value, tableMeta, updateValue) => {
       if(value=="Second Tap" || value=="Complete"){
         return ( <Chip
         color="primary"
         variant="outlined"
         label={value}
         icon={<Done/>}
       />);
       }else{
        return (
          <Chip
          variant="outlined"
          color={value=='USED'?"primary":"secondary"}
          label={value}
          icon={value=='USED'?<Done/>:<HourglassEmpty />}
       />     
        );
       }
    
    }
    },
    
   }
 ];


// options tickets 


const options2 = {
  textLabels: {
    body: {
      noMatch: "No tickets available"
    },
  },
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 100,
   elevation:0,
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
  <Box>    </Box>
  ),
 };



 // options luggage


 const options3 = {
  textLabels: {
    body: {
      noMatch: "No Luggage tickets available"
    },
  },
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 100,
   elevation:0,
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
  <Box>    </Box>
  ),
 };



 
 const options1 = {
  textLabels: {
    body: {
      noMatch: scheduleMessage
    },
  },
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:"single",
   rowsPerPage: 10,
   elevation:0,
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    <Box display="flex">
      <Permissions permissions="CAN_EDIT_SCHEDULE">
      <Chip
      color="secondary"
      variant="outlined"
      deleteIcon={<Edit/>}
      label={"Edit Schedule"}
      onClick={()=>{
      var id=displayData[selectedRows.data[0]['index']]['data'][0];
      var obj=schedules.find((item,i) => {
      return item.id == id;
      });

  setScheduleid(id);
  setVehicle({value:obj.vehicle_id,error:""});
  setRoute({value:obj.route_id,error:""});
  setDriver({value:obj.driver_id,error:""});
  setDate({value:obj.date_time,error:""});
  setTime({value:obj.date_time,error:""});
  setMode({value:obj.scheduling_mode,error:""});
  setDescription({value:"description",error:""});
  setDevice({value:"1",error:""});
  setAllowedSeats({value:obj.total_allowed_seats,error:""}); 

  var ExistingDate=obj.date_time.split(" ");

  console.log("date",ExistingDate[0]);

  console.log("time",ExistingDate[1]);

  var datetime = new Date(ExistingDate[0]);

  setScheduleDate({value:Format(datetime, ["yyyy-MM-dd"]),error:""});

  setScheduleTime({value:ExistingDate[1],error:""});
  
  setDialogedit(true);

      }}
      onDelete={()=>{

      }}
      className={classes.chip}
          />
      </Permissions>

      <Permissions permissions="CAN_EDIT_SCHEDULE">
           <Chip
      color="primary"
      variant="outlined"
      deleteIcon={<EditAttributes/>}
      label={"Change Status"}
      onClick={()=>{


      
        var id=displayData[selectedRows.data[0]['index']]['data'][0];
       
        var obj=schedules.find((item,i) => {
          return item.id ==id;
       })
        var stat=obj.status;
        setDescription({value:obj.description,error:""});
        setStatus({value:stat,error:""});
        // console.log("status:"+status.value);
        setScheduleid(id);
        // console.log("ID:"+id);
        
    
        setStatusdialog(true);
      }}
      onDelete={()=>{

      }}
      className={classes.chip}
          />
      </Permissions>


         <Chip
      color="primary"
      variant="outlined"
      deleteIcon={<CropFree/>}
      label={"Generate QR Code"}
      onClick={()=>{
        var id=displayData[selectedRows.data[0]['index']]['data'][0];
        generate_qr_code(id,"SCHEDULE");
      }}
      onDelete={()=>{
      }}
      className={classes.chip}
          />  
          
    <Permissions permissions="CAN_VIEW_VEHICLE_SALES_REPORT">

           <Chip
      color="primary"
      variant="outlined"
      deleteIcon={<ConfirmationNumber/>}
      label={"View sold tickets"}
      onClick={()=>{
        var id=displayData[selectedRows.data[0]['index']]['data'][0];
        console.log("schedule id",id);
        // var obj=schedules.find((s)=>s.id==id);
        get_tickets(id);
      }}
      onDelete={()=>{

      }}
      className={classes.chip}
          /> 
      
      </Permissions>
    
    </Box>
  ),
 };

 
 const optionsTrajet = {
  textLabels: {
    body: {
      noMatch: scheduleMessage
    },
  },
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:"single",
   rowsPerPage: 10,
   elevation:0,
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    <Box display="flex">
      {/* <Permissions permissions="CAN_EDIT_SCHEDULE">
      <Chip
      color="secondary"
      variant="outlined"
      deleteIcon={<Edit/>}
      label={"Edit Schedule"}
      onClick={()=>{
      var id=displayData[selectedRows.data[0]['index']]['data'][0];
      var obj=schedules.find((item,i) => {
      return item.id == id;
      });

  setScheduleid(id);
  setVehicle({value:obj.vehicle_id,error:""});
  setRoute({value:obj.route_id,error:""});
  setDriver({value:obj.driver_id,error:""});
  setDate({value:obj.date_time,error:""});
  setTime({value:obj.date_time,error:""});
  setMode({value:obj.scheduling_mode,error:""});
  setDescription({value:"description",error:""});
  setDevice({value:"1",error:""});
  setAllowedSeats({value:obj.total_allowed_seats,error:""});


  var ExistingDate=obj.date_time.split(" ");

  console.log("date",ExistingDate[0]);

  console.log("time",ExistingDate[1]);

  var datetime = new Date(ExistingDate[0]);

  setScheduleDate({value:Format(datetime, ["yyyy-MM-dd"]),error:""});

  setScheduleTime({value:ExistingDate[1],error:""});
  
  setDialogedit(true);

      }}
      onDelete={()=>{

      }}
      className={classes.chip}
          />
      </Permissions> */}

      {/* <Permissions permissions="CAN_EDIT_SCHEDULE">
           <Chip
      color="primary"
      variant="outlined"
      deleteIcon={<EditAttributes/>}
      label={"Change Status"}
      onClick={()=>{


      
        var id=displayData[selectedRows.data[0]['index']]['data'][0];
       
        var obj=schedules.find((item,i) => {
          return item.id ==id;
       })
        var stat=obj.status;
        setDescription({value:obj.description,error:""});
        setStatus({value:stat,error:""});
        // console.log("status:"+status.value);
        setScheduleid(id);
        // console.log("ID:"+id);
        
    
        setStatusdialog(true);
      }}
      onDelete={()=>{

      }}
      className={classes.chip}
          />
      </Permissions> */}


         <Chip
      color="primary"
      variant="outlined"
      deleteIcon={<CropFree/>}
      label={"Generate QR Code"}
      onClick={()=>{
        var id=displayData[selectedRows.data[0]['index']]['data'][0];
        generate_qr_code(id,"TRAJET");
      }}
      onDelete={()=>{
      }}
      className={classes.chip}
          />  
          
    {/* <Permissions permissions="CAN_VIEW_VEHICLE_SALES_REPORT">

           <Chip
      color="primary"
      variant="outlined"
      deleteIcon={<ConfirmationNumber/>}
      label={"View sold tickets"}
      onClick={()=>{
        var id=displayData[selectedRows.data[0]['index']]['data'][0];
        console.log("schedule id",id);
        // var obj=schedules.find((s)=>s.id==id);
        get_tickets(id);
      }}
      onDelete={()=>{

      }}
      className={classes.chip}
          /> 
      
      </Permissions> */}
    
    </Box>
  ),
 };




 // get routes

 const [loadRoutes,setLoadRoutes]=useState(false);
 const [routes,setRoutes]=useState([]);
 const getRoutes=(token)=>{
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const routesInstance = axios.create(new TransportService().setHeaders(token));
  setLoadRoutes(true);
  routesInstance.get("/api/v1/integrations/getRoutesByOrganization/"+new UserInfo().ORG_ID,{
   }).then(res=>{
     setLoadRoutes(false);
     console.log(res);
     console.log(res.data);
     if(res.status==200){
      const data=[];
      let d=res.data;
      d.sort((a, b)=>{    
        if (a['name'] > b['name']) {    
            return 1;    
        } else if (a['name'] < b['name']) {    
            return -1;    
        }    
        return 0;    
    } );
      if(d.length==0){
        setRouteMessage("No routes available");
      }
      d.map((dd)=>{
        if(dd['status']=="PLANED"){
          var obj={id:dd['id'],code:dd['code'],routeType:dd['route_type'],equivalence:dd['total_route_cost_rw_equivalence'],destination:dd['destination_stop']!==null?dd['destination_stop']['id']:0,origin:dd['origin_stop']!=null?dd['origin_stop']['id']:0,currency_id:dd['currency']!=null?dd['currency']['id']:0,id:dd['id'],code: dd['code'], name: dd['name'],discription:dd['description'],interval_time:dd['time_interval_minute'],distance:dd['total_route_distance_km'],cost:dd['total_route_cost'],currency:dd['currency']!=null?dd['currency']['code']:"No currency",status:dd['status']};
          data.push(obj);
        }        
      });
      setRoutes(data);
    }
   }).catch(err=>{
    setLoadRoutes(false);
   });
 }


// dialog schedule

const [scheduleDialog,setScheduleDialog]=useState(false);


//// get schedules

const [day,setDay]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});

const [nDrivers,setNDrivers]=useState(0);
const [nBuses,setNBuses]=useState(0);
const [nSchedules,setNSchedules]=useState(0);


const [routeId,setRouteId]=useState(0);

const [transferSchedules,setTransferSchedules]=useState([]);

const [schedules,setSchedules]=useState([]);
const [loadSchedule,setLoadschedule]=useState(false);

const getSchedules=(id,date)=>{

  setNDrivers(0);
  setNBuses(0);
  setNSchedules(0);
  setSchedules([]);
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const scheduleInstance = axios.create(new TransportService().setHeaders(operatorData.token));
  setLoadschedule(true);
  scheduleInstance.put('/api/v1/scheduling/getRouteIsSchedulesByDepartureDate',
  {
    "deperuredate":date,
    "routeId": id
  }
  )
  .then(res => {

    
    var unique_buses=[];
    var unique_drivers=[];

    console.log("=== schedules  ===",res.data);
    setLoadschedule(false);

      if(res.data.length!=0){
        let s=res.data;
        setNSchedules(s.length);
        const data=[];
    
        s.map((d)=>{
          if(d.driver!=null){
            var dFound=unique_drivers.findIndex((dd)=>dd==d['driver']['id']);
            if(dFound<0)unique_drivers.push(d['driver']['id']);

            var bFound=unique_buses.findIndex((b)=>b==d['vehicle']['id']);
            if(bFound<0)unique_buses.push(d['vehicle']['id']);

        

            var obj={id:d['id'],qrCodeValue:d['qrCodeValue'],updated_by:d['updated_by'],updated_at:d['updated_at'],created_at:d['created_at'],total_luggage_amount:d['total_luggage_amount'],number_of_luggages:d['number_of_luggages'],total_sales:d['total_sales'],scheduled_by:d['scheduledBy']!==null?d['scheduledBy']['names']:"-",driver_id:d['driver']['id'],total_allowed_seats:d['total_allowed_seats'],route_id:d['route']['id'],vehicle_id:d['vehicle']['id'],description:d['description'],date_time:d['scheduled_on_date_time'],driver_name: d['driver']!=null?d['driver']['first_name']+" "+d['driver']['last_name']:"No driver", code: d['code'], route: d['route']['name'], plate_number: d['vehicle']['number_plate'],total_seats:d['total_seats'],total_sold_seat:d['total_sold_seats'],scheduling_mode:d['scheduling_mode'],booked_seats:d['booked_seats'],booking_limit:d['booking_limit'],status:d['status'],total_from_head_sold_seats:d["total_from_head_sold_seats"]};
            data.push(obj);
          }else{
           
            var obj = { id: d['id'], qrCodeValue: d['qrCodeValue'], updated_by: d['updated_by'], updated_at: d['updated_at'], created_at: d['created_at'], total_luggage_amount: d['total_luggage_amount'], number_of_luggages: d['number_of_luggages'], total_sales: 0, scheduled_by: d['scheduledBy'] !== null ? d['scheduledBy']['names'] : "-", driver_id: 0, total_allowed_seats: 0, route_id: d['route']['id'], vehicle_id: 0, description: "", date_time: d['scheduled_on_date_time'], driver_name: "No driver", code: d['code'], route: d['route']['name'], plate_number: `${d['vehicle']['number_plate']}`,total_seats:d['total_seats'],total_sold_seat:d['total_sold_seats'],scheduling_mode:d['scheduling_mode'],booked_seats:d['booked_seats'],booking_limit:d['booking_limit'],status:d['status'],total_from_head_sold_seats:d['total_from_head_sold_seats']};
            data.push(obj);
          }
        });
    
        setSchedules(data);
        setTransferSchedules(data);
        setNDrivers(unique_drivers.length);
        setNBuses(unique_buses.length);
      }else{
        setScheduleMessage("No schedules available!");
      }
  }).catch(err=>{

    if(err.response){
      enqueueSnackbar(err.response.data.message, { 
        variant: 'info',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    }); 
    }

    

    setScheduleMessage("No schedule available");
    setLoadschedule(false);
    

    if(err.response){
      console.log(err.response);
    }
   
  });
}





//// load vehicle 

// vehicles to be hidden 

// const fincVehicle=(plate_number)=>{

//   console.log("======== plate number ==========");
//   console.log(plate_number);

// var hiddenVehicle=['RAD678','RAD436','RAE001H'];

// var find=false;

// for(var i=0;i<hiddenVehicle.length;i++){
//   if(hiddenVehicle[i].toLowerCase()==plate_number.toLowerCase()){
//     console.log("*********found*************"+hiddenVehicle[i]);
//     find=true;
//     break;
//   }
// }

// return find;
// }
   

const [vehicles,setVehicles]=useState([]);
const getVehicles=(token)=>{
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const vehicleInstance = axios.create(new TransportService().setHeaders(token));
  vehicleInstance.get('/api/v1/integrations/getActiveVehiclesByOrganization/'+new UserInfo().ORG_ID,{
    // vehicleInstance.get('/api/v1/integrations/getVehiclesByOrganization/'+new UserInfo().ORG_ID,{
    
  }).then(res=>{
    console.log("== vehicles ==",res.data);
    let data=res.data;
    const data_=[];
    data.map((o)=>{

      // var hiddenVehicle=['RAE920K','RAE921K','RAE922K','RAE923K','RAE924K','RAE925K','RAE926K','RAE927K','RAE929K','RAE904M','RAE906M','RAE880P','RAE881P','RAE882P','RAE367D','RAC211T','RAB170W','RAC199U',];

      // var found=hiddenVehicle.find((v)=>v==o.number_plate);

      // if(found==o.number_plate){
        
      // }else{
        data_.push(o);
      // }

      // if(found==="undefined"){
      //   data_.push(o);
      // }

      // console.log("========>"+found+"==========>")
      
    });

    data_.sort((a, b)=>{    
      if (a['number_plate'] > b['number_plate']) {    
          return 1;    
      } else if (a['number_plate'] < b['number_plate']) {    
          return -1;    
      }    
      return 0;    
    });

    setVehicles(data_);

  })
  .catch(err=>{

  });
}


///// load drivers


const [drivers,setDrivers]=useState([]);
const getDrivers=(token)=>{
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const driverInstance = axios.create(new TransportService().setHeaders(token));
  driverInstance.get("/api/v1/integrations/getDriversByOrganization/"+new UserInfo().ORG_ID
 ).then(res=>{
   console.log("driversssssssssss");
   console.log(res.data);
   if(res.status==200){
     var data=res.data;
     data.sort((a, b)=>{    
      if (a['first_name'] > b['first_name']) {    
          return 1;    
      } else if (a['first_name'] < b['first_name']) {    
          return -1;    
      }    
      return 0;    
    });
      setDrivers(data);     
   }else if(res.status==401){

   }
 });
}

// new schedule dialog 

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };




//// add new schedule
const [scheduleStatus,setSchedulestatus]=useState({load:false,status:false});
const [vehicle,setVehicle]=useState({value:"",error:""});
const [route,setRoute]=useState({value:"",error:""});
const [driver,setDriver]=useState({value:"",error:""});
const [date,setDate]=useState({value:"",error:""});
const [time,setTime]=useState({value:"",error:""});
const [mode,setMode]=useState({value:"",error:""});
const [endDate,setEndDate]=useState({value:"",error:""});


const [trajetType,setTrajetType]=useState({value:"",error:""});

const [description,setDescription]=useState({value:"",error:""});
const [device,setDevice]=useState({value:"",error:""});
const [scheduleDate,setScheduleDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
const [scheduleTime,setScheduleTime]=useState({value:Format(new Date(),["HH:mm"]) ,error:""}); 
const [allowedSeats,setAllowedSeats]=useState({value:0,error:""});


const onSaveSchedule=()=>{
  console.log("save schedule");
  if(vehicle.value===""){
    setVehicle({value:"",error:"Select vehicle"});
  }else if(routeId===0){
    setRoute({value:"",error:"Select route"});
  }else if(driver.value===""){
    setDriver({value:"",error:"Select driver"});
  }else if(mode.value===""){
    setMode({value:"",error:"Select mode"});
  }else if(allowedSeats.value<=0){
    setAllowedSeats({value:0,error:"Enter valid number"});
  }else{

    console.log("== save schedule ==");
    setSchedulestatus({load:true,status:false});
    let dt=scheduleDate.value+" "+scheduleTime.value+":00";
    // console.log("schedule date time",dt);
    // console.log("date time:"+date.value);
    // console.log("date time:"+dt);
    // console.log("driver:"+driver.value);
    // console.log("mode:"+mode.value);
    // console.log("vehicle:"+vehicle.value);
    // console.log("route:"+routeId);


    

    axios.defaults.baseURL = new TransportService().BASE_URL;
    const scheduleInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    scheduleInstance.post("/api/v1/scheduling/addSchedule",
      {
        "description": description.value,
        "device_id":"1",
        "driver_id": driver.value,
        "route_id": routeId,
        "scheduled_on_date_time": dt,
        "scheduling_mode": mode.value,
        "vehicle_id": vehicle.value,
        "total_allowed_seats": allowedSeats.value,
        "end_date": endDate.value,
      }
      ).then(res=>{
        setSchedulestatus({load:false,status:false});
       
          setSchedulestatus({load:false,status:true});
          setOpen(false);
          setTrajetDialog(false);
          enqueueSnackbar('Schedule successifuly created!', { 
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
          },
        });
        console.log("=====  schedule created ======");

        var objs=schedules;
        var r_obj= res.data?.data?.length > 0 ?
          res.data.data[0] : res.data.data
        console.log("== new schedule ==",r_obj);
        var obj={id:r_obj['id'],scheduled_by:r_obj['scheduledBy']['names'],updated_at:r_obj['updated_at'],updated_by:r_obj['updated_by'],created_at:r_obj['created_at'],driver_id:r_obj['driver']['id'],total_allowed_seats:r_obj['total_allowed_seats'],route_id:r_obj['route']['id'],vehicle_id:r_obj['vehicle']['id'],description:r_obj['description'],date_time:r_obj['scheduled_on_date_time'],driver_name: r_obj['driver']!=null?r_obj['driver']['first_name']+" "+r_obj['driver']['last_name']:"No driver", code: r_obj['code'], route: r_obj['route']['name'], plate_number: r_obj['vehicle']['number_plate'],total_seats:r_obj['total_seats'],total_sold_seat:r_obj['total_sold_seats'],scheduling_mode:r_obj['scheduling_mode'],booked_seats:r_obj['booked_seats'],booking_limit:r_obj['booking_limit'],status:r_obj['status']};
        objs.unshift(obj);
        setSchedules([]);
        setSchedules(objs); 
        setNSchedules(objs.length);
      
        setNBuses(nBuses+1);
        setNDrivers(nDrivers+1);

        
      })
      .catch(err=>{
        setSchedulestatus({load:false,status:false});
        if(err.response){
          enqueueSnackbar(err.response.data.message, { 
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
          },
        });
        }
      });
  }
}


// new shecdule trajet 


const [trajetDialog,setTrajetDialog]=useState(false);
const [trajetLoad,setTrajetLoad]=useState(false);

const [driverLisence,setDriverLisence]=useState({value:"",error:""});
const [each_after_minutes,setEach_after_minutes]=useState({value:0,error:""});
const [from_date,setFrom_date]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
const [to_date,setTo_date]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
const [from_working_hours,setFrom_working_hours]=useState({value:0,error:""});
const [to_working_hours,setTo_working_hours]=useState({value:0,error:""});
const [number_plate,setNumber_plate]=useState({value:"",error:""});
const [route_code,setRoute_code]=useState({value:"",error:""});
const [scheduling_mode,setScheduling_mode]=useState({value:"",error:""});
const [from_hour,setFrom_hour]=useState({value:0,error:""});
const [to_hour,setTo_hour]=useState({value:0,error:""});


const save_trajet_schedule=()=>{
  if(driverLisence.value==""){
    console.log("driver")
    setDriverLisence({value:"",error:"Select Driver"});
  }else if(each_after_minutes.value==0){
    console.log("minutes")
    setEach_after_minutes({value:0,error:"Enter minutes"});
  }else if(number_plate.value==""){
    console.log("vehicle")
    setNumber_plate({value:"",error:"Select vehicle"});
  }else if(route_code.value==""){
    console.log("route")
    setRoute_code({value:"",error:"Select route"});
  }else if(mode.value==""){
    console.log("mode");
    setMode({value:"",error:"Select scheduling mode"});
  }else{

    // console.log("driverLisence.value",driverLisence.value)
    // console.log("each_after_minutes.value",each_after_minutes.value)
    // console.log("from_date.value,",from_date.value)
    // console.log("from_working_hours.value",from_working_hours.value)
    // console.log("number_plate.value",number_plate.value)
    // console.log("route_code.value",route_code.value)
    // console.log("scheduling_mode.value",scheduling_mode.value)
    // console.log("to_date.value",to_date.value)
    // console.log("to_working_hours.value",to_working_hours.value)

    setTrajetLoad(true);

    axios.defaults.baseURL = new TransportService().BASE_URL;
    const trajetInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    trajetInstance.post('/api/v1/scheduling/createNewScheduleTrajet',


    // {
    //   "driving_license_number": "123456876542345",
    //   "each_after_minutes":30,
    //   "from_date": "2020-12-06",
    //   "from_working_hours":5,
    //   "number_plate": "RAE001B",
    //   "route_code": "GSZ8RH2B",
    //   "scheduling_mode": "SINGLE",
    //   "to_date": "2020-12-08",
    //   "to_working_hours":16
    // }
    
    {

      "driving_license_number": driverLisence.value,
      "each_after_minutes":each_after_minutes.value,
      "from_date": from_date.value,
      "from_working_hours": from_hour.value,
      "number_plate": number_plate.value,
      "route_code":route_code.value,
      "scheduling_mode": mode.value,
      "to_date": to_date.value,
      "to_working_hours": to_hour.value,
      "traject_type":trajetType.value
    }
    
    
    
    // {
    //   "driving_license_number": driverLisence.value,
    //   "each_after_minutes": each_after_minutes.value,
    //   "from_date": from_date.value,
    //   "from_working_hours": from_hour.value,
    //   "number_plate": number_plate.value,
    //   "route_code":route_code.value,
    //   "scheduling_mode": mode.value,
    //   "to_date": to_date.value,
    //   "to_working_hours": to_hour.value
    // }
    
    
    )
    .then(res=>{
      enqueueSnackbar('Trajet successifuly created!', { 
        variant: 'success',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });
      setTrajetDialog(false);
      setTrajetLoad(false);
    })
    .catch(err=>{
      setTrajetLoad(false);
      if(err.response){
        enqueueSnackbar(err.response.data.message, { 
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }
    });   
  }
}



// dialog edit  dialog

const [editDialog,setDialogedit]=useState(false);

// edit schedule 

const [editLoad,setEditLoad]=useState(false);
const edit_schedule=()=>{
  if(vehicle.value===""){
    setVehicle({value:"",error:"Select vehicle"});
  }else if(route.value===""){
    setRoute({value:"",error:"Select route"});
  }else if(driver.value===""){
    setDriver({value:"",error:"Select driver"});
  }else if(mode.value===""){
    setMode({value:"",error:"Select mode"});
  }else if(allowedSeats.value<=0){
    setAllowedSeats({value:0,error:"Enter valid value"});
  }
  else{

    /// substr the time if has length of 8
    var ttime=scheduleTime.value;
    if(scheduleTime.value.length==8){
      ttime=ttime.substr(0, 5);
    }
 
    let dt=scheduleDate.value+" "+ttime+":00";

    // console.log("description"+ description.value,
    // "device_id"+"1",
    // "driver_id"+ driver.value,
    // "id"+ scheduleId,
    // "route_id"+routeId,
    // "scheduled_on_date_time"+ dt,
    // "scheduling_mode"+ mode.value,
    // "vehicle_id"+ vehicle.value,
    // "allowed seats"+allowedSeats.value);

    setEditLoad(true);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const scheduleInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    scheduleInstance.put('/api/v1/scheduling/modifySchedule',
    {
        "description": description.value,
        "device_id": "1",
        "driver_id": driver.value,
        "id": scheduleId,
        "route_id": routeId,
        "scheduled_on_date_time": dt,
        "scheduling_mode": mode.value,
        "vehicle_id": vehicle.value,
        "total_allowed_seats": allowedSeats.value,
      }).
    then(res=>{

      console.log("===== after schedule edited =====");

      var r_obj=res.data.data;
      var obj={id:r_obj['id'],scheduled_by:r_obj['scheduledBy']['names'],updated_at:r_obj['updated_at'],updated_by:r_obj['updated_by'],created_at:r_obj['created_at'],driver_id:r_obj['driver']['id'],total_allowed_seats:r_obj['total_allowed_seats'],route_id:r_obj['route']['id'],vehicle_id:r_obj['vehicle']['id'],description:r_obj['description'],date_time:r_obj['scheduled_on_date_time'],driver_name: r_obj['driver']!=null?r_obj['driver']['first_name']+" "+r_obj['driver']['last_name']:"No driver", code: r_obj['code'], route: r_obj['route']['name'], plate_number: r_obj['vehicle']['number_plate'],total_seats:r_obj['total_seats'],total_sold_seat:r_obj['total_sold_seats'],scheduling_mode:r_obj['scheduling_mode'],booked_seats:r_obj['booked_seats'],booking_limit:r_obj['booking_limit'],status:r_obj['status']};
      var index=schedules.findIndex((s)=>s.id==scheduleId);
      var objs=schedules;
      objs[index]=obj;
      setSchedules(objs);


      setEditLoad(false);
      enqueueSnackbar('Schedule successifuly updated!', { 
        variant: 'success',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });
    setDialogedit(false);
    })
    .catch(err=>{

      setEditLoad(false);

      if(err.response){
        enqueueSnackbar(err.response.data.message, { 
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }

      enqueueSnackbar(err.message, { 
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });

    });

  }
}


// change status dialog

const [statusDialog,setStatusdialog]=useState(false);


const [anchorElStatus, setAnchorElStatus] = useState(null);

const handleEditOpenStatus = (event) => {
  setAnchorElStatus(event.currentTarget);
};

const handleEditCloseStatus = () => {
  setAnchorElStatus(null);
};

const openEditStatus = Boolean(anchorElStatus);
const idStatus = openEditStatus ? 'simple-popover' : undefined;



// change schedule status

const [scheduleId,setScheduleid]=useState(0);
const [statusLoad,setStatusload]=useState({load:false,status:false});
const [status,setStatus]=useState({value:"",error:""});
const changeSchedule=()=>{

  // if(description.value==""){
  //   setDescription({value:"",error:"Enter description"});
  // }
  
if(status.value==""){
    setStatus({value:"",error:"Choose status"});
  }

  else{
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const scheduleInstance = axios.create(new TransportService().setHeaders(operatorData.token));
  
    setStatusload({load:true,status:false});
    scheduleInstance .put("/api/v1/scheduling/changeScheduleStatus",
    {
      "description": "string",  //description.value,
      "schedule_id": scheduleId,
      "status":status.value
    }
    ).then(res=>{
      setStatusload({load:false,status:false});
      if(res.status===200){
        setStatusdialog(false);
        setStatusload({load:false,status:true});
        enqueueSnackbar('Schedule status changed successifuly!', { 
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      var objs=schedules;
      var index=objs.findIndex((o)=>o.id==scheduleId);
      var n_obj=res.data.data;
      var obj={id:n_obj['id'],scheduled_by:n_obj['scheduledBy']['names'],updated_by:n_obj['updated_by'],updated_at:n_obj['updated_at'],created_at:n_obj['created_at'],driver_id:n_obj['driver']['id'],total_allowed_seats:n_obj['total_allowed_seats'],route_id:n_obj['route']['id'],vehicle_id:n_obj['vehicle']['id'],description:n_obj['description'],date_time:n_obj['scheduled_on_date_time'],driver_name:n_obj['driver']!=null?n_obj['driver']['first_name']+" "+n_obj['driver']['last_name']:"No driver", code:n_obj['code'], route:n_obj['route']['name'], plate_number: n_obj['vehicle']['number_plate'],total_seats:n_obj['total_seats'],total_sold_seat:n_obj['total_sold_seats'],scheduling_mode:n_obj['scheduling_mode'],booked_seats:n_obj['booked_seats'],booking_limit:n_obj['booking_limit'],status:n_obj['status']};
      objs[index]=obj;
      setSchedules([]);
      setSchedules(objs); 
      handleEditCloseStatus(); 
      }
      
    }).catch(err=>{
      if(err.message){
        enqueueSnackbar(err.message, { 
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }

      if(err.response){
        enqueueSnackbar(err.response.data.message, { 
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }
      
    });


  } 
}

// generate qr code  dialog

const [qrDialog,setQrDialog]=useState(false);

// generate qr code 
const [qrIdentifier,setQrIdentifier]=useState(null);
const [qrLoad,setQrLoad]=useState(false);
const [qrStatus,setQrStatus]=useState(false);

const generate_qr_code=(id,schedule_type)=>{
  
  if(schedule_type=="SCHEDULE"){
  var obj=schedules.find((o)=>o.id==id);
  if(obj.qrCodeValue==null){
    setQrLoad(true);
    setQrDialog(true);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const qrInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    qrInstance.get('/api/v1/scheduling/generateQRCode/'+id
    ).then(res=>{
      var identifier=res.data.data.qr_code_itenfier;
      // console.log("identifier :"+id);
      var code="B"+identifier;
      var _schedules=schedules;
      var index=_schedules.findIndex((o)=>o.id==id);
      _schedules[index]['qrCodeValue']=identifier;
      setSchedules(_schedules);

      setQrIdentifier(code);
      setQrStatus(true);
      setQrLoad(false);
    }).catch(err=>{
  // console.log(err);
    }); 

  }else{
    setQrDialog(true);
    var code="B"+obj.qrCodeValue;
    setQrIdentifier(code);
    setQrStatus(true);  
  }
}else{
  var obj=trajets.find((o)=>o.id==id);
  if(obj.qrCodeValue==null){
    setQrLoad(true);
    setQrDialog(true);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const qrInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    qrInstance.get('/api/v1/scheduling/generateTrajectQRCode/'+id
    ).then(res=>{
      var identifier=res.data.data.qr_code_itenfier;
      // console.log("identifier :"+id);
      var code="T"+identifier;
      var _schedules=trajets;
      var index=_schedules.findIndex((o)=>o.id==id);
      _schedules[index]['qrCodeValue']=identifier;
      setTrajets(_schedules);

      setQrIdentifier(code);
      setQrStatus(true);
      setQrLoad(false);
    }).catch(err=>{
  // console.log(err);
    }); 

  }else{
    setQrDialog(true);
    var code="T"+obj.qrCodeValue;
    setQrIdentifier(code);
    setQrStatus(true);  
  }
}
  
}

// get schedule tickets dialog

const [ticketsDialog,setTicketsDialog]=useState(false);

//get schedule tickets 

const [ticketOption,setTicketOption]=useState("tickets");

const [luggageTickets,setLuggageTickets]=useState([]);


const [ticketsLoad,setTicketsLoad]=useState(false);
const [tickets,setTickets]=useState([]);
const get_tickets=(id)=>{

  setTickets([]);
  setLuggageTickets([]);
  setTicketsLoad(true);
  setTicketsDialog(true);
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const ticketsInstance = axios.create(new TransportService().setHeaders(operatorData.token));
  ticketsInstance.get('/api/v1/ticketing/getTicketsByScheule/'+id)
  .then(res=>{
    // console.log("===== schedule tickets ========");
    setTicketsLoad(false);
    if(res.data.length==0){
      console.log("No tickets available");
        setScheduleMessage("No tickets available!");
    }else{
      var e_objs=res.data;
     
      var objs=[];

      var luggageObjs=[];


      e_objs.map((o)=>{


        // if(o['channel_type']=="CARD" && o['ticket_type']=="ELECTRONIC"){

        if(o['status']!="CANCELED" && o['status']!="AC_GROUP_INCOMPLETE_PAYMENT"){
          if (o['ticket_type'] == "ELECTRONIC" || o['ticket_type'] == "CARD_TAPING"){


            // remove route code in the name of intermediate route

            if(o['intermediate_route']['stops_combination'].indexOf("#")>=0){
              var stop_combinations=o['intermediate_route']['stops_combination'].split("#");
              o['route']=stop_combinations[1];
            }else{
              var stop_combinations=o['intermediate_route']['stops_combination'];
              o['route']=stop_combinations;
            }



            var payment_mode=o['payment_mode'];
            if(payment_mode==='PROMOTION'){
              o['payment_mode']="CASHH";
            }


           

            
            // if(o['scheduling_mode']=="MULTIPLE"){
            //   if(o['status']=="USED"){
            //     if(o['channel_type']=="KIOSK" || o['channel_type']=='WEB')
            //     {
            //       o['status']="used";
            //     }else{
            //     o['status']="Second Tap";
            //     }
            //   }else{
            //     if(o['channel_type']=="KIOSK" || o['channel_type']=='WEB')
            //     {
            //       o['status']="pending";
            //     }else{
            //       o['status']="First Tap";
            //     }
                
            //   }
            // }else if(o['scheduling_mode']=="SINGLE"){
            //   o['status']="Complete";
            // }
            
          }else if(o['ticket_type']=="PAPER_BASED" ){
            o['status']=o['status'].toLowerCase();
            var payment_mode=o['payment_mode'];
            if(payment_mode==='PROMOTION'){
              o['payment_mode']="CASH";
            }

            if(o['intermediate_route']['stops_combination'].indexOf("#")>=0){
              var stop_combinations=o['intermediate_route']['stops_combination'].split("#");
              o['route']=stop_combinations[1];
            }else{
              var stop_combinations=o['intermediate_route']['stops_combination'];
              o['route']=stop_combinations;
            }
            
            // o['route']=o.intermediate_route.stops_combination;

          }

          if(o['owner_type']!="LUGGAGE" && o['owner_type']!="LUGGAGE_KG" && o['owner_type']!="LUGGAGE_VALUE" ){
            objs.push(o);
          }else{
            luggageObjs.push(o);
          }

          
        } 

    });
    if(e_objs.length==0){
      setScheduleMessage("No tickets available!");
    }
    setTickets(objs);
    setLuggageTickets(luggageObjs);
    }
  }).catch(err=>{
    enqueueSnackbar(err.message, { 
      variant: 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
  });
  });
}


//// open schedules


const [openSchedule,setOpenSchedule]=useState(false);


/// ticket details

const [ticketDialog,setTicketDialog]=useState(false);
const [ticketData,setTicketData]=useState({});



  // format money 

  function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  
      const negativeSign = amount < 0 ? "-" : "";
  
      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;
  
      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  };



  // transfer ticket  section 

  const [dayTransfer,setDayTransfer]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});


  const [anchorEl, setAnchorEl] = useState(null);

  const openTicket = Boolean(anchorEl);
  const id = openTicket ? 'simple-popover' : undefined;


  const openTicketMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const closeTicketMenu = () => {
    setAnchorEl(null);
  };


  const [transferDialog,setTransferDialog]=useState(false);


  const [scheduleNumber,setScheduleNumber]=useState({value:"",error:""});
  const [transferLoad,setTransferLoad]=useState(false);

  const transfer_ticket=()=>{
    if(scheduleNumber.value==""){
      setScheduleNumber({value:"",error:""});
    }else{
    setTransferLoad(true);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const transferInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    transferInstance.post('/api/v1/ticketing/processTicketTransfer',
    {
      "schedule_number": scheduleNumber.value,
      "ticket_number": ticketData.ticket_number,
      "transfer_fee": ticketData.first_amount_due
    })
    .then(res=>{

      setTransferDialog(false);

      var t=tickets.filter((t)=>t.id!=ticketData.id);
      setTickets(t);
      var index=schedules.findIndex((s)=>s.code==scheduleNumber.value);
      var objs=schedules;
      objs[index]['total_sold_seat']=parseInt(objs[index]['total_sold_seat'])+1;
      objs[index]['total_sales']=parseInt(objs[index]['total_sales'])+parseInt(ticketData.first_amount_due);
      
      setSchedules([]);

      setSchedules(objs);

      enqueueSnackbar("Ticket transfered well!", { 
        variant: 'success',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });

    setTransferLoad(false);

    setScheduleNumber({value:"",error:""});
    setTicketData({});

    })
    .catch(err=>{


      setTransferLoad(false);
      
      if(err.response){
        enqueueSnackbar(err.response.data.message, { 
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }else{
        enqueueSnackbar(err.message, { 
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }

    })

  }

  }


// load schedule for transfer ticket


const [loadTransferSchedules,setLoadTransferSchedules]=useState(false);
const getTransferSchedules=(date)=>{
  setTransferSchedules([]);
  setLoadTransferSchedules(true);
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const scheduleInstance = axios.create(new TransportService().setHeaders(operatorData.token));
  scheduleInstance.put('/api/v1/scheduling/getRouteIsSchedulesByDepartureDate',
  {
    "deperuredate":date,
    "routeId": routeId
  }
  )
  .then(res => {

    setLoadTransferSchedules(false);

      if(res.data.length!=0){
        let s=res.data;
        setNSchedules(s.length);
        const data=[];
    
        s.map((d)=>{
          if(d.driver!=null){
            var obj={id:d['id'],qrCodeValue:d['qrCodeValue'],total_luggage_amount:d['total_luggage_amount'],number_of_luggages:d['number_of_luggages'],total_sales:d['total_sales'],scheduled_by:d['scheduledBy']!==null?d['scheduledBy']['names']:"-",driver_id:d['driver']['id'],total_allowed_seats:d['total_allowed_seats'],route_id:d['route']['id'],vehicle_id:d['vehicle']['id'],description:d['description'],date_time:d['scheduled_on_date_time'],driver_name: d['driver']!=null?d['driver']['first_name']+" "+d['driver']['last_name']:"No driver", code: d['code'], route: d['route']['name'], plate_number: d['vehicle']['number_plate'],total_seats:d['total_seats'],total_sold_seat:d['total_sold_seats'],scheduling_mode:d['scheduling_mode'],booked_seats:d['booked_seats'],booking_limit:d['booking_limit'],status:d['status']};
            data.push(obj);
          }else{
            var obj={id:d['id'],qrCodeValue:d['qrCodeValue'],total_luggage_amount:d['total_luggage_amount'],number_of_luggages:d['number_of_luggages'],total_sales:0,scheduled_by:d['scheduledBy']!==null?d['scheduledBy']['names']:"-",driver_id:0,total_allowed_seats:0,route_id:d['route']['id'],vehicle_id:0,description:"",date_time:d['scheduled_on_date_time'],driver_name:"No driver", code: d['code'], route: d['route']['name'], plate_number: "",total_seats:d['total_seats'],total_sold_seat:d['total_sold_seats'],scheduling_mode:d['scheduling_mode'],booked_seats:d['booked_seats'],booking_limit:d['booking_limit'],status:d['status']};
            data.push(obj);
          }
        });
        setTransferSchedules(data);
      }else{
        // no schedules available
      }
  }).catch(err=>{

    setLoadTransferSchedules(false);
    
    if(err.response){
      enqueueSnackbar(err.response.data.message, { 
        variant: 'info',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    }); 
    }

   
    if(err.response){
      console.log(err.response);
    }
   
  });
}


 // get trajets

 const [dialogTrajet,setDialogTrajet]=useState(false);
 const [loadTrajet,setLoadTrajet]=useState(false);
 const [trajets,setTrajets]=useState([]);
 const getTrajets=()=>{
  setDialogTrajet(true)
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const routesInstance = axios.create(new TransportService().setHeaders(operatorData.token));
  setLoadTrajet(true);
  routesInstance.get("/api/v1/scheduling/findAllScheduleTrajects",{
   }).then(res=>{
    setLoadTrajet(false);
     console.log(res);
     console.log(res.data);
     setTrajets(res.data.data);
   }).catch(err=>{
    setLoadTrajet(false);
   });
 }



  return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			<Box className={classes.root}>
				<Box display='flex'>
					<Box
						display='flex'
						alignItems='center'
						mt={2}
						className={classes.formTitle}
					>
						<Box mr={1}>
							<Subway fontSize='large' color='primary' />
						</Box>{' '}
						<Typography variant='h5' color='default'>
							<b>Route Schedules</b>
						</Typography>
					</Box>
					{openSchedule == true && (
						<Box display='flex' height='50px'>
							<Permissions permissions='CAN_CREATE_SCHEDULE'>
								<Button
									className={classes.btn}
									size='small'
									startIcon={<Add />}
									onClick={() => {
										handleClickOpen();
									}}
									variant='outlined'
									disableElevation={true}
								>
									{matches && <Typography noWrap>New schedule</Typography>}
								</Button>
							</Permissions>

							<Button
								className={classes.btn}
								size='small'
								startIcon={<Add />}
								onClick={() => {
									setTrajetDialog(true);
								}}
								variant='outlined'
								disableElevation={true}
							>
								<Typography noWrap>New Trajet</Typography>
							</Button>

							<IconButton
								onClick={() => {
									setDialogTrajet(true);
									getTrajets();
								}}
								size='large'
								aria-label='delete'
							>
								<ListAlt fontSize='large' />
							</IconButton>

							<IconButton
								onClick={() => {
									setOpenSchedule(false);
								}}
							>
								<CancelPresentation fontSize='large' style={{ color: 'red' }} />
							</IconButton>
						</Box>
					)}{' '}
				</Box>

				{/* route table  */}
				{openSchedule == false ? (
					<Box mt={2}>
						{loadRoutes && <LinearProgress />}
						<MUIDataTable
							title={'Route Schedules list'}
							data={routes}
							columns={columns}
							options={options}
						/>
					</Box>
				) : (
					<Box mt={2}>
						<Box mt={1} mb={1}>
							<Grid container spacing={1}>
								{/* drivers  */}

								<Grid item xs={12} md={4}>
									<Paper className={classes.paper} elevation={0}>
										<Grid container>
											<Grid item xs={8} md={8}>
												<Box display='flex' justifyContent='center'>
													<Typography variant='h6'>Drivers</Typography>
												</Box>
												<Box mt={2} display='flex' justifyContent='center'>
													<Typography variant='h5'>{nDrivers}</Typography>
												</Box>
											</Grid>

											<Grid item xs={4} md={4}>
												<Box p={1}>
													<img src={Idrivers} width='80px' height='80px' />
												</Box>
											</Grid>
										</Grid>
									</Paper>
								</Grid>

								{/* buses  */}

								<Grid item xs={12} md={4}>
									<Paper className={classes.paper} elevation={0}>
										<Grid container>
											<Grid item xs={8} md={8}>
												<Box display='flex' justifyContent='center'>
													<Typography variant='h6'>Buses</Typography>
												</Box>
												<Box mt={2} display='flex' justifyContent='center'>
													<Typography variant='h5'>{nBuses}</Typography>
												</Box>
											</Grid>
											<Grid item xs={4} md={4}>
												<Box p={1}>
													<img src={Ibuses} width='80px' height='80px' />
												</Box>
											</Grid>
										</Grid>
									</Paper>
								</Grid>

								{/* schedules  */}

								<Grid item xs={12} md={4}>
									<Paper className={classes.paper} elevation={0}>
										<Grid container>
											<Grid item xs={8} md={8}>
												<Box display='flex' justifyContent='center'>
													<Typography variant='h6'>Schedules</Typography>
												</Box>
												<Box mt={2} display='flex' justifyContent='center'>
													<Typography variant='h5'>{nSchedules}</Typography>
												</Box>
											</Grid>
											<Grid item xs={4} md={4}>
												<Box p={1}>
													<img src={Ischedules} width='80px' height='80px' />
												</Box>
											</Grid>
										</Grid>
									</Paper>
								</Grid>
							</Grid>
						</Box>

						{/* <Dialog fullScreen open={scheduleDialog} style={{marginTop:"80px"}}  onClose={()=>{
  setScheduleDialog(false);
}} TransitionComponent={Transition}>
       <AppBar className={classes.appBar}>
         <Toolbar>
           <IconButton edge="start" color="inherit" onClick={()=>{
             setSchedules([]);
 setScheduleDialog(false);
}} aria-label="close">
             <Close />
           </IconButton>
           <Typography variant="h6" className={classes.title}>
             Schedules
           </Typography>
           <Button  
className={classes.btn}
size="small"
startIcon={<Add/>} 
onClick={()=>{handleClickOpen()}} 
variant="outlined" 
disableElevation={true}>
<Typography noWrap>New schedule</Typography>
</Button>

<Button  
className={classes.btn}
size="small"
startIcon={<Add/>} 
onClick={()=>{
 setTrajetDialog(true);
}} 
variant="outlined" 
disableElevation={true}>
<Typography noWrap>New Trajet</Typography>
</Button>

         </Toolbar>
       </AppBar> */}

						{loadSchedule && <LinearProgress />}
						<MUIDataTable
							title={
								<Box display='flex'>
									<Box>
										<DatePicker
											style={{ height: 50 }}
											fullWidth
											variant='inline'
											format='yyyy-MM-dd'
											margin='dense'
											autoOk
											label='Date'
											value={day.value}
											inputVariant='outlined'
											onChange={(v) => {
												setDay({ value: Format(v, ['yyyy-MM-dd']), error: '' });

												getSchedules(routeId, Format(v, ['yyyy-MM-dd']));
											}}
											InputProps={{
												disableUnderline: true,
												style: { paddingRight: 0 },
											}}
										/>
									</Box>
									<Box ml={3} mt={2}>
										<Typography>{routeName}</Typography>
									</Box>
								</Box>
							}
							data={schedules}
							columns={columns1}
							options={options1}
						/>

						{/* </Dialog> */}
					</Box>
				)}

				{/* get schedule tickets  */}

				<Dialog
					fullScreen
					open={ticketsDialog}
					style={{ marginTop: '50px' }}
					onClose={() => {
						setTicketsDialog(false);
					}}
					TransitionComponent={Transition}
				>
					<AppBar className={classes.appBar}>
						<Toolbar>
							<IconButton
								edge='start'
								color='inherit'
								onClick={() => {
									setTicketsDialog(false);
								}}
								aria-label='close'
							>
								<Close />
							</IconButton>
							<Typography variant='h6' className={classes.title}>
								Tickets
							</Typography>
							<Button
								autoFocus
								color='inherit'
								onClick={() => {
									setTicketsDialog(false);
								}}
							>
								Close
							</Button>
						</Toolbar>
					</AppBar>
					<Box mt={3} display='flex' justifyContent='center'>
						<ButtonGroup color='primary' disableElevation={true}>
							<Button
								variant={ticketOption == 'tickets' ? 'contained' : 'outlined'}
								onClick={() => {
									setTicketOption('tickets');
								}}
							>
								Passenger Tickets <b>({tickets.length})</b>
							</Button>
							<Button
								variant={ticketOption == 'luggages' ? 'contained' : 'outlined'}
								onClick={() => {
									setTicketOption('luggages');
								}}
							>
								Passenger Luggages <b>({luggageTickets.length}) </b>
							</Button>
						</ButtonGroup>
					</Box>
					
					<Box mt={2}>
						{ticketsLoad && <LinearProgress />}
						{ticketOption === 'tickets' ? (
							<MUIDataTable
								title={'Passenger Tickets list'}
								data={tickets}
								columns={columns2}
								options={options2}
							/>
						) : (
							<MUIDataTable
								title={'Luggage Tickets list'}
								data={luggageTickets}
								columns={columns3}
								options={options3}
							/>
						)}
					</Box>
				</Dialog>

				{/* dialog new schedule  */}

				<Dialog
					maxWidth='sm'
					fullWidth
					open={open}
					onClose={handleClose}
					aria-labelledby='new branch'
					aria-describedby='new bramnch'
				>
					<DialogTitle id='new schedule'>{'New Schedule'}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							<Box>
								<Box
									mt={1}
									display='flex'
									alignItems='center'
									justifyContent='center'
								>
									<Grid container spacing={1}>
										<Grid item xs={12} md={6} lg={6} sm={6}>
											<FormControl
												size='small'
												variant='outlined'
												fullWidth
												className={classes.formControl}
											>
												<InputLabel htmlFor='selectpos'>
													Choose Vehicle
												</InputLabel>
												<Select
													value={vehicle.value === ''}
													size='small'
													label='Select vehicle'
													inputProps={{
														name: 'vehicle',
														id: 'select vehicle',
													}}
													error={vehicle.error !== ''}
													onChange={(e) => {
														if (e.target.value === '') {
															setVehicle({
																value: '',
																error: 'Select vehicle',
															});
														} else {
															var obj = vehicles.find(
																(v) => v.id == e.target.value
															);
															setAllowedSeats({
																value: obj.total_number_of_seats,
																error: '',
															});
															setVehicle({ value: e.target.value, error: '' });
														}
													}}
												>
													<MenuItem value=''>
														<em>None</em>
													</MenuItem>
													{vehicles.map((v) => {
														return (
															<MenuItem value={v['id']}>
																{v['number_plate']}
															</MenuItem>
														);
													})}
												</Select>
												<FormHelperText error={vehicle.error !== ''}>
													{vehicle.error}
												</FormHelperText>
											</FormControl>
										</Grid>

										<Grid item xs={12} md={6} lg={6} sm={6}>
											<TextField
												fullWidth
												type='number'
												onChange={(e) => {
													if (e.target.value <= 0) {
														setAllowedSeats({
															value: 0,
															error: 'Enter valid number',
														});
													} else {
														setAllowedSeats({
															value: e.target.value,
															error: '',
														});
													}
												}}
												size='small'
												value={allowedSeats.value}
												error={allowedSeats.error != ''}
												helperText={allowedSeats.error}
												id='allowedseats'
												label='Allowed Seats'
												variant='outlined'
											/>
										</Grid>
									</Grid>
								</Box>

								{/* <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
<InputLabel htmlFor="route">Choose Route</InputLabel>
        <Select
        size="small"
        helperText={"error"} 
        label="Select route"
        inputProps={{
          name: 'route',
          id: 'route',
        }}
        error={route.error!==""}
        onChange={(e)=>{
          if(e.target.value===''){
            setRoute({value:"",error:"Select route"});
          }else{
            setRoute({value:e.target.value,error:""});
          }
        }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {routes.map((r)=>{
            if(r.status!=="INITIAL"){
              return <MenuItem value={r['id']}>{r['name']}</MenuItem>
            }
            return null;
          })}
          
        </Select>
        <FormHelperText error={route.error!==""}>{route.error}</FormHelperText>
      </FormControl>
</Box> */}

								<Box
									mt={1}
									display='flex'
									alignItems='center'
									justifyContent='center'
								>
									<FormControl
										size='small'
										variant='outlined'
										fullWidth
										className={classes.formControl}
									>
										<InputLabel htmlFor='driver'>Choose Driver</InputLabel>
										<Select
											value={driver.value === ''}
											size='small'
											helperText={'error'}
											label='Select driver'
											inputProps={{
												name: 'driver',
												id: 'driver',
											}}
											error={driver.error !== ''}
											onChange={(e) => {
												if (e.target.value === '') {
													setDriver({ value: '', error: 'Select driver' });
												} else {
													setDriver({ value: e.target.value, error: '' });
												}
											}}
										>
											<MenuItem value=''>
												<em>None</em>
											</MenuItem>
											{drivers.map((d) => {
												return (
													<MenuItem value={d['id']}>
														{d['first_name'] + ' ' + d['last_name']}
													</MenuItem>
												);
											})}
										</Select>
										<FormHelperText error={driver.error !== ''}>
											{driver.error}
										</FormHelperText>
									</FormControl>
								</Box>
								<Box
									mt={1}
									display='flex'
									alignItems='center'
									justifyContent='center'
								>
									<Grid container>
										<Grid md={6} xs={12} lg={6}>
											<Box mr={1}>
												<DatePicker
													fullWidth
													disableToolbar
													variant='inline'
													format='yyyy-MM-dd'
													margin='dense'
													disablePast
													autoOk
													label='Date'
													value={scheduleDate.value}
													inputVariant='outlined'
													onChange={(v) => {
														// console.log("choosen2: ",v);
														setScheduleDate({
															value: Format(v, ['yyyy-MM-dd']),
															error: '',
														});
													}}
													InputProps={{
														disableUnderline: true,
														style: { paddingRight: 1 },
													}}
												/>
											</Box>
										</Grid>

										<Grid md={6} xs={12} lg={6}>
											<Box ml={1} mt={1}>
												{/* <FormControl>
      <InputLabel>react-text-mask</InputLabel>
      <Input
        value={textmask}
        onChange={()=>{

        }}
        inputComponent={TextMaskCustom}
        inputProps={{
          mask:  [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
        }}
      />
    </FormControl> */}

												{/* <MaskedInput
                   fullWidth
                   placeholder={scheduleTime.value}
                   value={scheduleTime.value}
          mask={[/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/]}
          type='text'
          onChange={(e)=>{
console.log("date",e.target.value);
          }}
        /> */}

												<TextField
													fullWidth
													size='small'
													defaultValue={scheduleTime.value}
													// label="Time"
													variant='outlined'
													InputProps={{
														inputComponent: TextMaskCustom,
														value: scheduleTime.value,
														onChange: (e) => {
															setScheduleTime({
																value: e.target.value,
																error: '',
															});
														},
													}}
												/>

												{/* <TextField
                   fullWidth
                   size="small"
    id="time"
    // label="Time"
    type="time"
    variant="outlined"
    defaultValue={scheduleTime.value}

    onChange={(e)=>{
      console.log("time",e.target.value);
      if(e.target.value.length==5){
        setScheduleTime({value:e.target.value,error:""});
      }
      
    }}
   
    inputProps={{
      step: 300, // 5 min
    }}
  /> */}
											</Box>
										</Grid>

										{/* <Grid md={6} xs={12} lg={6}>
                <Box ml={1}>
                <TimePicker
                            ampm={false}
                            fullWidth
                            openTo="hours"
                            views={["hours", "minutes", "seconds"]}
                            format="HH:mm:ss"
                            variant="inline"
                            margin="dense"
                            disablePast
                            autoOk
                            label="Time"
                            value={scheduleTime.value}
                            inputVariant="outlined"
                            onChange={(v)=>{
                                setScheduleTime({value:v,error:""});
                            }}
                            InputProps={{
                              disableUnderline: true,
                              style: { paddingRight: 1 },
                            }}
                          />
               </Box>

               
               
                </Grid> */}
									</Grid>
								</Box>
								<Box
									mt={1}
									display='flex'
									alignItems='center'
									justifyContent='center'
								>
									<FormControl
										size='small'
										variant='outlined'
										fullWidth
										className={classes.formControl}
									>
										<InputLabel htmlFor='mode'>
											Choose scheduling mode
										</InputLabel>
										<Select
											value={mode.value === ''}
											size='small'
											helperText={'error'}
											label='Select mode'
											inputProps={{
												name: 'mode',
												id: 'mode',
											}}
											error={mode.error !== ''}
											onChange={(e) => {
												if (e.target.value === '') {
													setMode({ value: '', error: 'Select mode' });
												} else {
													setMode({ value: e.target.value, error: '' });
												}
											}}
										>
											<MenuItem value=''>
												<em>None</em>
											</MenuItem>
											<MenuItem value={'SINGLE'}>Single</MenuItem>
											<MenuItem value={'MULTIPLE'}>Multiple</MenuItem>
										</Select>
										<FormHelperText error={mode.error !== ''}>
											{mode.error}
										</FormHelperText>
									</FormControl>
								</Box>

								<Box mt={1}>
									<FormControl
										size='small'
										variant='outlined'
										fullWidth
										className={classes.formControl}
									>
										<TextField
											size='small'
											rowsMax={5}
											rows={10}
											variant='outlined'
											label={'Description'}
											error={description.error != ''}
											helperText={description.error}
											onChange={(e) => {
												if (e.target.value == '') {
													setDescription({
														value: '',
														error: 'Enter description',
													});
												} else {
													setDescription({ value: e.target.value, error: '' });
												}
											}}
											color='primary'
											fullWidth
											multiline
										/>
									</FormControl>
								</Box>
							</Box>
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={handleClose}
							variant='outlined'
							color='secondary'
							autoFocus
						>
							Cancel
						</Button>
						<Button
							disabled={scheduleStatus.load}
							disableElevation
							onClick={onSaveSchedule}
							variant='contained'
							color='primary'
						>
							{scheduleStatus.load ? (
								<CircularProgress size={25} color='secondary' />
							) : (
								'Save'
							)}
						</Button>
					</DialogActions>
				</Dialog>

				{/* dialog edit schedule  */}

				<Dialog
					maxWidth='sm'
					fullWidth
					open={trajetDialog}
					onClose={() => {
						setTrajetDialog(false);
					}}
					aria-labelledby='new_trajet'
					aria-describedby='new_trajet'
				>
					<DialogTitle id='new_trajet'>{'New Trajet'}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							<Box>
								<Box
									mt={1}
									display='flex'
									alignItems='center'
									justifyContent='center'
								>
									<Grid container spacing={1}>
										<Grid item xs={12} md={6} lg={6} sm={6}>
											<FormControl
												size='small'
												variant='outlined'
												fullWidth
												className={classes.formControl}
											>
												<InputLabel htmlFor='selectpos'>
													Choose Vehicle
												</InputLabel>
												<Select
													size='small'
													label='Select vehicle'
													inputProps={{
														name: 'vehicle',
														id: 'select vehicle',
													}}
													error={vehicle.error !== ''}
													onChange={(e) => {
														if (e.target.value === '') {
															setVehicle({
																value: '',
																error: 'Select vehicle',
															});
														} else {
															var obj = vehicles.find(
																(v) => v.id == e.target.value
															);
															setAllowedSeats({
																value: obj.total_number_of_seats,
																error: '',
															});
															setVehicle({ value: e.target.value, error: '' });
														}
													}}
												>
													<MenuItem value=''>
														<em>None</em>
													</MenuItem>
													{vehicles.map((v) => {
														return (
															<MenuItem value={v['id']}>
																{v['number_plate']}
															</MenuItem>
														);
													})}
												</Select>
												<FormHelperText error={vehicle.error !== ''}>
													{vehicle.error}
												</FormHelperText>
											</FormControl>
										</Grid>
										<Grid item xs={12} md={6} lg={6} sm={6}>
											<TextField
												fullWidth
												type='number'
												onChange={(e) => {
													if (e.target.value <= 0) {
														setAllowedSeats({
															value: 0,
															error: 'Enter valid number',
														});
													} else {
														setAllowedSeats({
															value: e.target.value,
															error: '',
														});
													}
												}}
												size='small'
												value={allowedSeats.value}
												error={allowedSeats.error != ''}
												helperText={allowedSeats.error}
												id='allowedseats'
												label='Allowed Seats'
												variant='outlined'
											/>
										</Grid>
									</Grid>
								</Box>

								{/* <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
     
   <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
   
   <InputLabel htmlFor="route">Choose Route</InputLabel>
           <Select
           size="small"
           helperText={"error"} 
           label="Select route"
           defaultValue={route.value}
           inputProps={{
             name: 'route',
             id: 'route',
           }}
           error={route.error!==""}
           onChange={(e)=>{
             if(e.target.value===''){
               setRoute({value:"",error:"Select route"});
             }else{
               setRoute({value:e.target.value,error:""});
             }
           }}
           >
             <MenuItem value="">
               <em>None</em>
             </MenuItem>
             {routes.map((r)=>{
               if(r.status=="PLANED"){
                 return <MenuItem value={r['id']}>{r['name']}</MenuItem>
               }
               return null;
             })}
             
           </Select>
           <FormHelperText error={route.error!==""}>{route.error}</FormHelperText>
         </FormControl>
   </Box>
    */}

								<Box
									mt={1}
									display='flex'
									alignItems='center'
									justifyContent='center'
								>
									<FormControl
										size='small'
										variant='outlined'
										fullWidth
										className={classes.formControl}
									>
										<InputLabel htmlFor='driver'>Choose Driver</InputLabel>
										<Select
											size='small'
											helperText={'error'}
											label='Select driver'
											inputProps={{
												name: 'driver',
												id: 'driver',
											}}
											error={driver.error !== ''}
											onChange={(e) => {
												if (e.target.value === '') {
													setDriver({ value: '', error: 'Select driver' });
												} else {
													setDriver({ value: e.target.value, error: '' });
												}
											}}
										>
											<MenuItem value=''>
												<em>None</em>
											</MenuItem>
											{drivers.map((d) => {
												return (
													<MenuItem value={d['id']}>
														{d['first_name'] + ' ' + d['last_name']}
													</MenuItem>
												);
											})}
										</Select>
										<FormHelperText error={driver.error !== ''}>
											{driver.error}
										</FormHelperText>
									</FormControl>
								</Box>
								<Box
									mt={1}
									display='flex'
									alignItems='center'
									justifyContent='center'
								>
									<Grid container>
										<Grid md={6} xs={12} lg={6}>
											<Box mr={1}>
												<DatePicker
													fullWidth
													disableToolbar
													variant='inline'
													format='yyyy-MM-dd'
													margin='dense'
													autoOk
													label='Date'
													value={scheduleDate.value}
													inputVariant='outlined'
													onChange={(v) => {
														console.log('choosen2: ', v);
														setScheduleDate({
															value: Format(v, ['yyyy-MM-dd']),
															error: '',
														});
													}}
													InputProps={{
														disableUnderline: true,
														style: { paddingRight: 1 },
													}}
												/>
											</Box>
										</Grid>
										<Grid md={6} xs={12} lg={6}>
											<Box ml={1} mt={1}>
												<TextField
													fullWidth
													size='small'
													defaultValue={scheduleTime.value}
													// label="Time"
													variant='outlined'
													InputProps={{
														inputComponent: TextMaskCustom,
														value: scheduleTime.value,
														onChange: (e) => {
															setScheduleTime({
																value: e.target.value,
																error: '',
															});
														},
													}}
												/>

												{/* 
    <TextField
    fullWidth
    size="small"
    id="time"
    label="Time"
    type="time"
    variant="outlined"
    defaultValue={scheduleTime.value}

    onChange={(e)=>{
      console.log("time",e.target.value);
      setScheduleTime({value:e.target.value+":00",error:""});
    }}
   
    inputProps={{
      step: 300, // 5 min
    }}
  /> */}
												{/* <TimePicker
                               ampm={false}
                               fullWidth
                               openTo="hours"
                               views={["hours", "minutes", "seconds"]}
                               format="HH:mm:ss"
                               variant="inline"
                               margin="dense"
                               disablePast
                               autoOk
                               label="Time"
                               value={scheduleTime.value}
                               inputVariant="outlined"
                               onChange={(v)=>{
                                   setScheduleTime({value:v,error:""});
                               }}
                               InputProps={{
                                 disableUnderline: true,
                                 style: { paddingRight: 1 },
                               }}
                             /> */}
											</Box>
										</Grid>
									</Grid>
								</Box>
								<Box
									mt={1}
									display='flex'
									alignItems='center'
									justifyContent='center'
								>
									<FormControl
										size='small'
										variant='outlined'
										fullWidth
										className={classes.formControl}
									>
										<DatePicker
											fullWidth
											disableToolbar
											variant='inline'
											format='yyyy-MM-dd'
											margin='dense'
											autoOk
											label='End date'
											value={endDate.value}
											inputVariant='outlined'
											onChange={(v) => {
												setEndDate({
													value: Format(v, ['yyyy-MM-dd']),
													error: '',
												});
											}}
											InputProps={{
												disableUnderline: true,
												style: { paddingRight: 1 },
											}}
										/>
									</FormControl>
								</Box>
								<Box
									mt={1}
									display='flex'
									alignItems='center'
									justifyContent='center'
								>
									<FormControl
										size='small'
										variant='outlined'
										fullWidth
										className={classes.formControl}
									>
										<InputLabel htmlFor='mode'>
											Choose scheduling mode
										</InputLabel>
										<Select
											size='small'
											helperText={'error'}
											label='Select mode'
											inputProps={{
												name: 'mode',
												id: 'mode',
											}}
											error={mode.error !== ''}
											onChange={(e) => {
												if (e.target.value === '') {
													setMode({ value: '', error: 'Select mode' });
												} else {
													setMode({ value: e.target.value, error: '' });
												}
											}}
										>
											<MenuItem value=''>
												<em>None</em>
											</MenuItem>
											<MenuItem value={'SINGLE'}>Single</MenuItem>
											<MenuItem value={'MULTIPLE'}>Multiple</MenuItem>
										</Select>
										<FormHelperText error={mode.error !== ''}>
											{mode.error}
										</FormHelperText>
									</FormControl>
								</Box>

								<Box mt={1}>
									<FormControl
										size='small'
										variant='outlined'
										fullWidth
										className={classes.formControl}
									>
										<TextField
											value={description.value}
											size='small'
											rowsMax={10}
											rows={10}
											variant='outlined'
											label={'Description'}
											error={description.error != ''}
											helperText={description.error}
											onChange={(e) => {
												if (e.target.value == '') {
													setDescription({
														value: '',
														error: 'Enter description',
													});
												} else {
													setDescription({ value: e.target.value, error: '' });
												}
											}}
											color='primary'
											fullWidth
											multiline
										/>
									</FormControl>
								</Box>
							</Box>
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={() => {
								setTrajetDialog(false);
							}}
							variant='outlined'
							color='secondary'
						>
							Cancel
						</Button>
						<Button
							disabled={editLoad}
							autoFocus
							disableElevation
							onClick={() => {
								onSaveSchedule();
							}}
							variant='contained'
							color='primary'
						>
							{editLoad ? (
								<CircularProgress size={25} color='secondary' />
							) : (
								'Save'
							)}
						</Button>
					</DialogActions>
				</Dialog>

				{/* dialog new schedule trajet and edit */}

				<Dialog
					maxWidth='sm'
					fullWidth
					open={editDialog || open}
					onClose={
						editDialog
							? () => {
									handleEditCloser()
							  }
							: handleClose
					}
					aria-labelledby='new branch'
					aria-describedby='new bramnch'
				>
					<DialogTitle id='new schedule'>
						{editDialog ? 'Edit Schedule' : 'New Schedule'}
					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							<Box>
								<Box
									mt={1}
									display='flex'
									alignItems='center'
									justifyContent='center'
								>
									<Grid container spacing={1}>
										<Grid item xs={12} md={6} lg={6} sm={6}>
											<FormControl
												size='small'
												variant='outlined'
												fullWidth
												className={classes.formControl}
											>
												<InputLabel htmlFor='selectpos'>
													Choose Vehicle
												</InputLabel>
												<Select
                          defaultValue={vehicle.value}
													size='small'
													label='Select vehicle'
													inputProps={{
														name: 'vehicle',
														id: 'select vehicle',
													}}
													error={vehicle.error !== ''}
													onChange={(e) => {
														if (e.target.value === '') {
															setVehicle({
																value: '',
																error: 'Select vehicle',
															});
														} else {
															var obj = vehicles.find(
																(v) => v.id == e.target.value
															);
															setAllowedSeats({
																value: obj.total_number_of_seats,
																error: '',
															});
															setVehicle({ value: e.target.value, error: '' });
														}
													}}
												>
													<MenuItem value=''>
														<em>None</em>
													</MenuItem>
													{vehicles.map((v) => {
														return (
															<MenuItem value={v['id']}>
																{v['number_plate']}
															</MenuItem>
														);
													})}
												</Select>
												<FormHelperText error={vehicle.error !== ''}>
													{vehicle.error}
												</FormHelperText>
											</FormControl>
										</Grid>

										<Grid item xs={12} md={6} lg={6} sm={6}>
											<TextField
												fullWidth
												type='number'
												onChange={(e) => {
													if (e.target.value <= 0) {
														setAllowedSeats({
															value: 0,
															error: 'Enter valid number',
														});
													} else {
														setAllowedSeats({
															value: e.target.value,
															error: '',
														});
													}
												}}
												size='small'
												value={allowedSeats.value}
												error={allowedSeats.error != ''}
												helperText={allowedSeats.error}
												id='allowedseats'
												label='Allowed Seats'
												variant='outlined'
											/>
										</Grid>
									</Grid>
								</Box>

								{/* <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
<InputLabel htmlFor="route">Choose Route</InputLabel>
        <Select
        size="small"
        helperText={"error"} 
        label="Select route"
        inputProps={{
          name: 'route',
          id: 'route',
        }}
        error={route.error!==""}
        onChange={(e)=>{
          if(e.target.value===''){
            setRoute({value:"",error:"Select route"});
          }else{
            setRoute({value:e.target.value,error:""});
          }
        }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {routes.map((r)=>{
            if(r.status!=="INITIAL"){
              return <MenuItem value={r['id']}>{r['name']}</MenuItem>
            }
            return null;
          })}
          
        </Select>
        <FormHelperText error={route.error!==""}>{route.error}</FormHelperText>
      </FormControl>
</Box> */}

								<Box
									mt={1}
									display='flex'
									alignItems='center'
									justifyContent='center'
								>
									<FormControl
										size='small'
										variant='outlined'
										fullWidth
										className={classes.formControl}
									>
										<InputLabel htmlFor='driver'>Choose Driver</InputLabel>
										<Select
                     defaultValue={
                        driver.value 
                     }
											size='small'
											helperText={'error'}
											label='Select driver'
											inputProps={{
												name: 'driver',
												id: 'driver',
											}}
											error={driver.error !== ''}
											onChange={(e) => {
												if (e.target.value === '') {
													setDriver({ value: '', error: 'Select driver' });
												} else {
													setDriver({ value: e.target.value, error: '' });
												}
											}}
										>
											<MenuItem value=''>
												<em>None</em>
											</MenuItem>
											{drivers.map((d) => {
												return (
													<MenuItem value={d['id']}>
														{d['first_name'] + ' ' + d['last_name']}
													</MenuItem>
												);
											})}
										</Select>
										<FormHelperText error={driver.error !== ''}>
											{driver.error}
										</FormHelperText>
									</FormControl>
								</Box>
								<Box
									mt={1}
									display='flex'
									alignItems='center'
									justifyContent='center'
								>
									<Grid container>
										<Grid md={6} xs={12} lg={6}>
											<Box mr={1}>
												<DatePicker
													fullWidth
													disableToolbar
													variant='inline'
													format='yyyy-MM-dd'
													margin='dense'
													disablePast
													autoOk
													label='Date'
													value={scheduleDate.value}
													inputVariant='outlined'
													onChange={(v) => {
														// console.log("choosen2: ",v);
														setScheduleDate({
															value: Format(v, ['yyyy-MM-dd']),
															error: '',
														});
													}}
													InputProps={{
														disableUnderline: true,
														style: { paddingRight: 1 },
													}}
												/>
											</Box>
										</Grid>

										<Grid md={6} xs={12} lg={6}>
											<Box ml={1} mt={1}>
												{/* <FormControl>
      <InputLabel>react-text-mask</InputLabel>
      <Input
        value={textmask}
        onChange={()=>{

        }}
        inputComponent={TextMaskCustom}
        inputProps={{
          mask:  [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
        }}
      />
    </FormControl> */}

												{/* <MaskedInput
                   fullWidth
                   placeholder={scheduleTime.value}
                   value={scheduleTime.value}
          mask={[/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/]}
          type='text'
          onChange={(e)=>{
console.log("date",e.target.value);
          }}
        /> */}

												<TextField
													fullWidth
													size='small'
													defaultValue={scheduleTime.value}
													// label="Time"
													variant='outlined'
													InputProps={{
														inputComponent: TextMaskCustom,
														value: scheduleTime.value,
														onChange: (e) => {
															setScheduleTime({
																value: e.target.value,
																error: '',
															});
														},
													}}
												/>

												{/* <TextField
                   fullWidth
                   size="small"
    id="time"
    // label="Time"
    type="time"
    variant="outlined"
    defaultValue={scheduleTime.value}

    onChange={(e)=>{
      console.log("time",e.target.value);
      if(e.target.value.length==5){
        setScheduleTime({value:e.target.value,error:""});
      }
      
    }}
   
    inputProps={{
      step: 300, // 5 min
    }}
  /> */}
											</Box>
										</Grid>

										{/* <Box
											mt={1}
											display='flex'
											alignItems='center'
											justifyContent='center'
										>
											<FormControl
												size='small'
												variant='outlined'
												fullWidth
												className={classes.formControl}
											>
												<DatePicker
													fullWidth
													disableToolbar
													variant='inline'
													format='yyyy-MM-dd'
													margin='dense'
													disablePast
													autoOk
													label='Enddate'
													value={endDate.value}
													inputVariant='outlined'
													onChange={(v) => {
														// console.log("choosen2: ",v);
														setEndDate({
															value: Format(v, ['yyyy-MM-dd']),
															error: '',
														});
													}}
													InputProps={{
														disableUnderline: true,
														style: { paddingRight: 1 },
													}}
												/>
											</FormControl>
										</Box> */}

										{/* <Grid md={6} xs={12} lg={6}>
                <Box ml={1}>
                <TimePicker
                            ampm={false}
                            fullWidth
                            openTo="hours"
                            views={["hours", "minutes", "seconds"]}
                            format="HH:mm:ss"
                            variant="inline"
                            margin="dense"
                            disablePast
                            autoOk
                            label="Time"
                            value={scheduleTime.value}
                            inputVariant="outlined"
                            onChange={(v)=>{
                                setScheduleTime({value:v,error:""});
                            }}
                            InputProps={{
                              disableUnderline: true,
                              style: { paddingRight: 1 },
                            }}
                          />
               </Box>

               
               
                </Grid> */}
									</Grid>
								</Box>
								<Box
									mt={1}
									display='flex'
									alignItems='center'
									justifyContent='center'
								>
									<FormControl
										size='small'
										variant='outlined'
										fullWidth
										className={classes.formControl}
									>
										<InputLabel htmlFor='mode'>
											Choose scheduling mode
										</InputLabel>
										<Select
                     value={mode.value}
											size='small'
											helperText={'error'}
											label='Select mode'
											inputProps={{
												name: 'mode',
												id: 'mode',
											}}
											error={mode.error !== ''}
											onChange={(e) => {
												if (e.target.value === '') {
													setMode({ value: '', error: 'Select mode' });
												} else {
													setMode({ value: e.target.value, error: '' });
												}
											}}
										>
											<MenuItem value=''>
												<em>None</em>
											</MenuItem>
											<MenuItem value={'SINGLE'}>Single</MenuItem>
											<MenuItem value={'MULTIPLE'}>Multiple</MenuItem>
										</Select>
										<FormHelperText error={mode.error !== ''}>
											{mode.error}
										</FormHelperText>
									</FormControl>
								</Box>

								<Box mt={1}>
									<FormControl
										size='small'
										variant='outlined'
										fullWidth
										className={classes.formControl}
									>
										<TextField
											size='small'
											rowsMax={5}
											rows={10}
											variant='outlined'
											label={'Description'}
											error={description.error != ''}
											helperText={description.error}
											onChange={(e) => {
												if (e.target.value == '') {
													setDescription({
														value: '',
														error: 'Enter description',
													});
												} else {
													setDescription({ value: e.target.value, error: '' });
												}
											}}
											color='primary'
											fullWidth
											multiline
										/>
									</FormControl>
								</Box>
							</Box>
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={
								editDialog
									? () => {
											handleEditCloser()
									  }
									: handleClose
							}
							variant='outlined'
							color='secondary'
							autoFocus
						>
							Cancel
						</Button>
						<Button
							disabled={scheduleStatus.load}
							disableElevation
							onClick={
								editDialog
									? () => {
											edit_schedule();
									  }
									: onSaveSchedule
							}
							variant='contained'
							color='primary'
						>
							{scheduleStatus.load ? (
								<CircularProgress size={25} color='secondary' />
							) : (
								'Save'
							)}
						</Button>
					</DialogActions>
				</Dialog>

				{/* change schedule status  */}

				<Dialog
					maxWidth='sm'
					fullWidth
					open={statusDialog}
					onClose={() => {
						setStatusdialog(false);
					}}
					aria-labelledby='new branch'
					aria-describedby='new bramnch'
				>
					<DialogTitle id='change_status_schedule'>
						{'Change schedule status'}
					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							<Box>
								<Box
									mt={1}
									display='flex'
									alignItems='center'
									justifyContent='center'
								>
									<FormControl
										size='small'
										variant='outlined'
										fullWidth
										className={classes.formControl}
									>
										<InputLabel htmlFor='status'>Choose status</InputLabel>
										<Select
											size='small'
											helperText={'error'}
											label='Select status'
											inputProps={{
												name: 'status',
												id: 'status',
											}}
											value={status.value}
											error={status.error !== ''}
											onChange={(e) => {
												if (e.target.value === '') {
													setStatus({ value: '', error: 'Selec status' });
												} else {
													setStatus({ value: e.target.value, error: '' });
												}
											}}
										>
											<MenuItem value=''>
												<em>None</em>
											</MenuItem>
											<MenuItem
												value={'INITIAL'}
												selected={status.value == 'INITIAL' ? true : false}
											>
												Initial
											</MenuItem>
											<MenuItem
												value={'SCHEDULED'}
												selected={status.value == 'SCHEDULED' ? true : false}
											>
												Scheduled
											</MenuItem>
											<MenuItem
												value={'CANCELED'}
												selected={status.value == 'CANCELED' ? true : false}
											>
												Canceled
											</MenuItem>
											<MenuItem
												value={'CLOSED'}
												selected={status.value == 'CLOSED' ? true : false}
											>
												Closed
											</MenuItem>
										</Select>
										<FormHelperText error={mode.error !== ''}>
											{mode.error}
										</FormHelperText>
									</FormControl>
								</Box>

								<Box mt={1}>
									<FormControl
										size='small'
										variant='outlined'
										fullWidth
										className={classes.formControl}
									>
										<TextField
											size='small'
											rowsMax={10}
											rows={10}
											variant='outlined'
											label={'Description'}
											error={description.error != ''}
											helperText={description.error}
											onChange={(e) => {
												if (e.target.value == '') {
													setDescription({
														value: '',
														error: 'Enter description',
													});
												} else {
													setDescription({ value: e.target.value, error: '' });
												}
											}}
											value={description.value}
											color='primary'
											fullWidth
											multiline
										/>
									</FormControl>
								</Box>
							</Box>
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={() => {
								setStatusdialog(false);
							}}
							variant='outlined'
							color='secondary'
							autoFocus
						>
							Cancel
						</Button>
						<Button
							disabled={statusLoad.load}
							disableElevation
							onClick={() => {
								changeSchedule();
							}}
							variant='contained'
							color='primary'
						>
							{statusLoad.load ? (
								<CircularProgress size={25} color='secondary' />
							) : (
								'Save'
							)}
						</Button>
					</DialogActions>
				</Dialog>

				{/* generate schedule Qr code   */}

				<Dialog
					maxWidth='sm'
					fullWidth
					open={qrDialog}
					onClose={() => {
						setQrDialog(false);
					}}
					aria-labelledby='generate_qr'
					aria-describedby='generate_qr'
				>
					<DialogTitle id='generate_qr'>{'Generate Qr Code'}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{qrLoad ? (
								<Box>
									<Grid container>
										<Grid md={2} xs={2} lg={2} sm={2}>
											<CircularProgress disableShrink color='primary' />
										</Grid>
										<Grid md={10} xs={10} lg={10} sm={10}>
											<Typography>Generating QR Code</Typography>
										</Grid>
									</Grid>
								</Box>
							) : (
								<Box>
									<Box
										mt={1}
										display='flex'
										alignItems='center'
										justifyContent='center'
									>
										<QRCode value={qrIdentifier} />
									</Box>
								</Box>
							)}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={() => {
								setQrDialog(false);
							}}
							variant='outlined'
							color='secondary'
						>
							Close
						</Button>
					</DialogActions>
				</Dialog>
			</Box>

			{/* ticket details  */}

			<Dialog
				maxWidth='sm'
				fullWidth
				open={ticketDialog}
				onClose={() => {
					setTicketDialog(false);
					setTicketData({});
				}}
				aria-labelledby='ticket_details'
				aria-describedby='ticket_details'
			>
				<DialogTitle id='ticket_details'>{'Ticket details'}</DialogTitle>
				<DialogContent>
					<DialogContentText>
						<Box>
							<Grid container>
								<Grid item xs={12} md={6} lg={6} sm={6}>
									<Box
										mt={1}
										display='flex'
										alignItems='center'
										justifyContent='center'
									>
										<QRCode
											value={
												ticketData.ticket_number != undefined &&
												ticketData.ticket_number
											}
											size={100}
										/>
									</Box>
									<Box display='flex' justifyContent='center'>
										<List>
											<ListItem dense>
												<ListItemIcon>
													<PersonOutlined />
												</ListItemIcon>
												<ListItemText
													primary={
														<b>
															{ticketData.customer_names != undefined &&
																ticketData.customer_names}
														</b>
													}
												/>
											</ListItem>

											<ListItem dense>
												<ListItemIcon>
													<AirportShuttle />
												</ListItemIcon>
												<ListItemText
													primary={
														<b>
															{ticketData.intermediate_route != undefined &&
																ticketData.intermediate_route.stops_combination}
														</b>
													}
												/>
											</ListItem>

											<ListItem dense>
												<ListItemIcon>
													<ScheduleIcon />
												</ListItemIcon>
												<ListItemText
													primary={
														<b>
															{ticketData.schedule != undefined &&
																ticketData.schedule.scheduled_on_date_time}
														</b>
													}
												/>
											</ListItem>

											<ListItem dense>
												<ListItemIcon>
													<Money />
												</ListItemIcon>
												<ListItemText
													primary={
														<b>
															{ticketData.actual_ticket_amount != undefined &&
																ticketData.actual_ticket_amount}{' '}
															{ticketData.currency != undefined &&
																ticketData.currency}
														</b>
													}
												/>
											</ListItem>

											<ListItem dense>
												<ListItemIcon>
													<AirlineSeatReclineNormal />
												</ListItemIcon>
												<ListItemText
													primary={
														<b>
															{ticketData.seat_number != undefined &&
																ticketData.seat_number}
														</b>
													}
												/>
											</ListItem>
										</List>
									</Box>
								</Grid>
								{matches && (
									<Grid item xs={12} md={6} lg={6} sm={6}>
										<img src={iticketdetails} />
									</Grid>
								)}
							</Grid>
						</Box>
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							setTicketDialog(false);
							setTicketData({});
						}}
						variant='outlined'
						color='secondary'
						autoFocus
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>

			{/* transfer ticket  */}

			<Dialog
				maxWidth='sm'
				fullWidth
				open={transferDialog}
				onClose={() => {
					setTransferDialog(false);
					setTicketData({});
				}}
				aria-labelledby='ticket_details'
				aria-describedby='ticket_details'
			>
				<DialogTitle id='ticket_details'>{'Transfer Ticket'}</DialogTitle>
				<DialogContent>
					<DialogContentText>
						<Box>
							<Box
								mt={1}
								display='flex'
								alignItems='center'
								justifyContent='center'
							>
								{loadTransferSchedules && <LinearProgress />}
								<DatePicker
									style={{ height: 50 }}
									fullWidth
									variant='inline'
									format='yyyy-MM-dd'
									margin='dense'
									autoOk
									label='Date'
									value={dayTransfer.value}
									inputVariant='outlined'
									onChange={(v) => {
										setDayTransfer({
											value: Format(v, ['yyyy-MM-dd']),
											error: '',
										});
										getTransferSchedules(Format(v, ['yyyy-MM-dd']));
									}}
									InputProps={{
										disableUnderline: true,
										style: { paddingRight: 0 },
									}}
								/>
							</Box>

							<Box
								mt={1}
								display='flex'
								alignItems='center'
								justifyContent='center'
							>
								<FormControl
									size='small'
									variant='outlined'
									fullWidth
									className={classes.formControl}
								>
									<InputLabel htmlFor='status'>Select schedule</InputLabel>
									<Select
										size='small'
										helperText={'error'}
										label='Select status'
										inputProps={{
											name: 'status',
											id: 'status',
										}}
										// value={status.value}
										error={scheduleNumber.error !== ''}
										onChange={(e) => {
											if (e.target.value === '') {
												setScheduleNumber({ value: '', error: 'Selec status' });
											} else {
												setScheduleNumber({ value: e.target.value, error: '' });
											}
										}}
									>
										<MenuItem value=''>
											<em>None</em>
										</MenuItem>
										{transferSchedules.map((s) => {
											var schedule_date = Format(parseISO(s.date_time), [
												'yyyy-MM-dd H:mm',
											]);

											return (
												<MenuItem value={s.code}>
													{schedule_date + '   (' + s.route + ')'}
												</MenuItem>
											);
										})}
									</Select>
									<FormHelperText error={scheduleNumber.error !== ''}>
										{mode.error}
									</FormHelperText>
								</FormControl>
							</Box>
						</Box>
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							setTransferDialog(false);
							setTicketData({});
						}}
						variant='outlined'
						color='secondary'
					>
						Cancel
					</Button>
					<Button
						disabled={transferLoad}
						onClick={() => {
							transfer_ticket();
						}}
						variant='outlined'
						color='primary'
						autoFocus
					>
						{transferLoad ? (
							<CircularProgress size={25} color='secondary' />
						) : (
							'Transfer'
						)}
					</Button>
				</DialogActions>
			</Dialog>

			{/* start trajet list */}

			<Dialog
				fullScreen
				open={dialogTrajet}
				style={{ marginTop: '50px' }}
				onClose={() => {
					setDialogTrajet(false);
				}}
				TransitionComponent={Transition}
			>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<IconButton
							edge='start'
							color='inherit'
							onClick={() => {
								setDialogTrajet(false);
							}}
							aria-label='close'
						>
							<Close />
						</IconButton>
						<Typography variant='h6' className={classes.title}>
							List of Trajets
						</Typography>
						<Button
							autoFocus
							color='inherit'
							onClick={() => {
								setDialogTrajet(false);
							}}
						>
							Close
						</Button>
					</Toolbar>
				</AppBar>

				<Box mt={2}>
					{loadTrajet && <LinearProgress />}

					<MUIDataTable
						title={'List of Trajet'}
						//  title={
						// <Box  display="flex">
						// <Box>
						//  <DatePicker
						//  style={{height:50}}
						//    fullWidth
						//    variant="inline"
						//    format="yyyy-MM-dd"
						//    margin="dense"
						//    autoOk
						//    label="Date"
						//    value={day.value}
						//    inputVariant="outlined"
						//    onChange={(v)=>{
						//     setDay({value:Format(v, ["yyyy-MM-dd",]),error:""});
						//     getSchedules(routeId,Format(v, ["yyyy-MM-dd",]));
						//    }}
						//    InputProps={{
						//      disableUnderline: true,
						//      style: { paddingRight: 0 },
						//    }}
						//  />
						// </Box>
						// <Box ml={3} mt={2}>
						//   <Typography >{routeName}</Typography>
						//   </Box>
						//   </Box>
						//   }
						data={trajets}
						columns={columnsTrajet}
						options={optionsTrajet}
					/>
				</Box>
			</Dialog>

			{/* end trajet list  */}
		</MuiPickersUtilsProvider>
	);


  function GetTicketSchedule(props) {
    const [ticket, setTicket] = useState({ status: "loading" });
    const id = props?.id;
  
    useEffect(() => {
      console.log("calculate tickets",id);
      var data = {};
      const data1 = localStorage.getItem("nx_op");
      if (data1 != null) {
        data = JSON.parse(data1);
      }

      if (ticket.data == null) {
        console.log(ticket.data)
        getTicket(data.token);
      }
     
    }, [ticket]);
  
    const getTicket = (token) => {
      axios.defaults.baseURL = new TransportService().BASE_URL;
      const ticketInstance = axios.create(new TransportService().setHeaders(token));
      ticketInstance.get("/api/v1/scheduling/getScheduleTotalSoldTickets/"+id)
        .then(function (response) {
          const d = response.data;
          setTicket({ data:d.data,status:"success"});
        })
        .catch(function (error) {
          if (error.response) {
            if (error?.response?.status == 404) {
              setTicket({ data: 0, status: "empty" });
            } else {
              setTicket({ data: 0, status: "error" });
            }
          } else {
            setTicket({ data: 0, status: "error" });
            // this is the example of getting ticket immediately from serve without waitting ...
        
          }
          
        });
  
      ////
    };
  
    return( <>
                          {ticket?.data != null ? (
                           <Typography>{ticket?.data}</Typography>
                          ) : (
                              <Typography>Loading...</Typography>
                            )}
    </>)
  }
  
}



export default  withLocalize(RouteSchedule)